/* ALL THE SCRIPTS IN THIS FILE ARE MADE BY KROWNTHEMES.COM --- REDISTRIBUTION IS NOT ALLOWED! */

$(window).bind("pageshow", function (event) {
  if (event.originalEvent.persisted) {
    window.location.reload();
  }
});

$.ajaxSetup({ cache: false });

// CONTINUE WITH EVERYTHING ELSE

window.blockStickyHeader = false;

(function ($) {
  window.__CUBER_DEBUG__ = window.__CUBER_DEBUG__ || {
    counts: {},
    inc: function (name, meta) {
      this.counts[name] = (this.counts[name] || 0) + 1;
      if (meta !== undefined) {
        console.log('[CUBER][' + name + '] init count:', this.counts[name], meta);
      } else {
        console.log('[CUBER][' + name + '] init count:', this.counts[name]);
      }
      return this.counts[name];
    }
  };
  $("#site-filters select:not(.styled)").each(function () {

    $(this).parent().append($.themeAssets.arrowDown);

    if ($(this).data("label") != "") {
      if ($(this).find("option:selected").hasClass("default")) {
        $(this)
          .parent()
          .find(".regular-select-inner")
          .html($(this).data("label"));
      }

      $(this).on("change", function (e) {
        if ($(this).find("option:selected").hasClass("default")) {
          $(this)
            .parent()
            .find(".regular-select-inner")
            .html($(this).data("label"));
        }
      });
    }
  });

  if ($("#js-helpers").length === 0) {
    $(".site-header").append(
      '<span id="js-helpers"><span id="fix-me-header"></span><span id="fix-me-collection"></span></span>'
    );
  }

  // tab navigation

  $("a:not(.ach), button, span, input")
    .off("focus.cuberHover blur.cuberHover")
    .on("focus.cuberHover", function () {
      $(this).addClass("hover");
    })
    .on("blur.cuberHover", function () {
      $(this).removeClass("hover");
    });

  $(document)
  .off("keyup.cuberEscape")
  .on("keyup.cuberEscape", function (e) {
    if (e.keyCode === 27) {
      $(".site-close-handle").trigger("click");
    }
  });

  // We start with the newsletter code (it needs to be wrapped inside a $(window).load() event function in order to get the perfect timeout after the site has completely loaded

  window.CUBER = {
    // MAIN

    Nav: {
      $siteHeader: null,
      $siteNav: null,
      $siteOverlay: null,

      mount: function () {
        this.$siteHeader = $("#site-header");
        this.$siteNav = $("#site-nav--mobile");
        this.$siteOverlay = $("#site-overlay");

        $("#site-menu-handle").off("click.cuberNav focusin.cuberNav").on(
          "click.cuberNav focusin.cuberNav",
          function () {
            if (!this.$siteNav.hasClass("active")) {
              this.$siteNav.addClass("active");
              this.$siteNav
                .removeClass("show-filters")
                .removeClass("show-cart")
                .removeClass("show-search");

              this.$siteOverlay.addClass("active");

              $(".fixing-scroll-now .site-box-background").addClass(
                "sidebar-move"
              );
              $("body").addClass("sidebar-move");
            }
          }.bind(this)
        );

        if ($("#site-filter-handle").length > 0) {
          $("#site-filter-handle").off("click.cuberNav").on(
            "click.cuberNav",
            function () {
              if (!this.$siteNav.hasClass("active")) {
                this.$siteNav.addClass("active");
                this.$siteNav
                  .removeClass("show-cart")
                  .removeClass("show-search")
                  .addClass("show-filters");

                this.$siteOverlay.addClass("active");

                $(".fixing-scroll-now .site-box-background").addClass(
                  "sidebar-move"
                );
                $("body").addClass("sidebar-move");
              }
            }.bind(this)
          );
        }

        if ($("#site-search-handle").length > 0) {
          $("#site-search-handle a").addClass("block-fade");

          $("#site-search-handle a").off("click.cuberNav").on(
          "click.cuberNav",
          function (e) {
              e.preventDefault();

              if (!this.$siteNav.hasClass("active")) {
                if ($("html").hasClass("ie9")) {
                  document.location.href = "/search";
                } else {
                  this.$siteNav.addClass("active");
                  this.$siteNav
                    .removeClass("show-filters")
                    .removeClass("show-cart")
                    .addClass("show-search");

                  this.$siteOverlay.addClass("active");

                  $(".fixing-scroll-now .site-box-background").addClass(
                    "sidebar-move"
                  );
                  $("body").addClass("sidebar-move");

                  $('form.search-bar input[type="search"]').focus();
                }
              }
            }.bind(this)
          );

          $("#site-search-handle")
            .off("mouseenter.cuberNav mouseleave.cuberNav focusout.cuberNav")
            .on("mouseenter.cuberNav", function () {
              $(this).addClass("hover-in").removeClass("hover-out");
            })
            .on("mouseleave.cuberNav focusout.cuberNav", function () {
              $(this).addClass("hover-out").removeClass("hover-in");
            });

          $('a[href="#search"]')
          .off("click.cuberNav")
          .on("click.cuberNav", function (e) {
            e.preventDefault();
            $("#site-search-handle a").trigger("click");
          });
        }

        $(".site-close-handle, #site-overlay").off("click.cuberNav").on(
          "click.cuberNav",
          function () {
            if (this.$siteNav.hasClass("active")) {
              this.$siteNav.removeClass("active");
              this.$siteOverlay.removeClass("active");

              $(".fixing-scroll-now .site-box-background").removeClass(
                "sidebar-move"
              );
              $("body").removeClass("sidebar-move");
            }
          }.bind(this)
        );

        $(".site-nav.style--classic .has-submenu").each(function () {
          $(this)
            .off("mouseenter.cuberNav focusin.cuberNav mouseleave.cuberNav focusout.cuberNav")
            .on("mouseenter.cuberNav focusin.cuberNav", function () {
              $(this).find(".submenu").stop().slideDown(200);
              $("body").addClass("opened-submenu");
              $("body").addClass("opened-submenu-flag");
              $(".site-overlay").addClass("active");
              $(this).find(".submenu").attr("aria-expanded", "true");
            })
            .on("mouseleave.cuberNav focusout.cuberNav", function () {
              $(this).find(".submenu").attr("aria-expanded", "false");
              $(this)
                .find(".submenu")
                .stop()
                .slideUp(200, function () {
                  if (!$("body").hasClass("opened-submenu-flag")) {
                    $("body").removeClass("opened-submenu");
                  }
                });
              $(".site-overlay").removeClass("active");
              $("body").removeClass("opened-submenu-flag");
            });
        });

        $(".site-nav.style--sidebar .has-submenu:not(.collections-menu)").each(
          function () {
            $(this).children("a").addClass("block-fade");
            $(this)
              .children("a")
              .off("click.cuberNav touchstart.cuberNav")
              .on("click.cuberNav touchstart.cuberNav", function (e) {
                e.preventDefault();
                var $parent = $(this).parent();

                if ($parent.hasClass("active")) {
                  var tempBoNo = false;
                  var tempBoHref = $(this).attr("href");

                  if (tempBoHref != "") {
                    if (tempBoHref.indexOf("#") >= 0) {
                      tempBoNo = true;

                      if (tempBoHref.indexOf("#") == tempBoHref.length - 1) {
                        // nothing
                      } else {
                        $(".site-close-handle").trigger("click");
                        document.location.href = tempBoHref;
                      }
                    } else if ($(this).attr("target") == "_blank") {
                      window.open(tempBoHref, "_blank");
                    } else {
                      $("body").fadeOut(200);
                      setTimeout(
                        function () {
                          document.location.href = tempBoHref;
                        }.bind(this),
                        200
                      );
                      e.preventDefault();
                    }
                  } else {
                    tempBoNo = true;
                  }

                  if (tempBoNo) {
                    $parent.find(".submenu").stop().slideUp(200);
                    $parent.removeClass("active");
                    $parent.find(".submenu").attr("aria-expanded", "false");
                  }
                } else {
                  $parent.addClass("active");
                  $parent.find(".submenu").stop().slideDown(200);
                  $parent.find(".submenu").attr("aria-expanded", "true");
                }

                $(this).removeClass("hover");
              });
          }
        );

        $(".site-nav.style--sidebar .has-babymenu:not(.collections-menu)").each(
          function () {
            $(this).children("a").addClass("block-fade");
            $(this)
              .children("a")
              .off("click.cuberNav touchstart.cuberNav")
              .on("click.cuberNav touchstart.cuberNav", function (e) {
                e.preventDefault();
                var $parent = $(this).parent();

                if ($parent.hasClass("active")) {
                  var tempBoNo = false;
                  var tempBoHref = $(this).attr("href");

                  if (tempBoHref != "") {
                    if (tempBoHref.indexOf("#") >= 0) {
                      tempBoNo = true;

                      if (tempBoHref.indexOf("#") == tempBoHref.length - 1) {
                        // nothing
                      } else {
                        $(".site-close-handle").trigger("click");
                        document.location.href = tempBoHref;
                      }
                    } else if ($(this).attr("target") == "_blank") {
                      window.open(tempBoHref, "_blank");
                    } else {
                      $("body").fadeOut(200);
                      setTimeout(
                        function () {
                          document.location.href = tempBoHref;
                        }.bind(this),
                        200
                      );
                      e.preventDefault();
                    }
                  } else {
                    tempBoNo = true;
                  }

                  if (tempBoNo) {
                    $parent.removeClass("active");
                    $parent.find(".babymenu").stop().slideUp(200);
                    $parent.find(".babymenu").attr("aria-expanded", "false");
                  }
                } else {
                  $parent.addClass("active");
                  $parent.find(".babymenu").stop().slideDown(200);
                  $parent.find(".babymenu").attr("aria-expanded", "true");
                }
              });
          }
        );

        $(".style--classic .babymenu").each(function () {
          var bestWidth = 0;
          $(this).parent().parent().css("display", "block");

          $(this)
            .find("a")
            .each(function () {
              $(this).css("position", "fixed");
              $(this).attr("data-width", $(this).outerWidth(true));
              if ($(this).outerWidth() > bestWidth) {
                bestWidth = $(this).outerWidth(true);
              }
              $(this).css({ position: "static", width: "100%" });
            });

          bestWidth += 30;
          $(this).css("width", bestWidth);
          $(this).css("transform", "translateX(-45%)");
          $(this).parent().parent().css("display", "none");
          $(this).css("display", "none");
        });

        $(".style--classic .has-babymenu").each(function () {
          $(this)
          .off("mouseenter.cuberNav focusin.cuberNav mouseleave.cuberNav focusout.cuberNav")
            .on("mouseenter.cuberNav focusin.cuberNav", function () {
              $(this).find(".babymenu").stop().slideDown(200);
              $(this).find(".babymenu ul").attr("aria-expanded", "true");
              $(this).css("zIndex", 9);
            })
            .on("mouseleave.cuberNav focusout.cuberNav", function () {
              $(this).find(".babymenu").stop().slideUp(200);
              $(this).find(".babymenu ul").attr("aria-expanded", "false");
              $(this).css("zIndex", 1);
            });
        });

        $("body").addClass("desktop--add-some-padding");

        $(".style--classic li.has-submenu[data-size]").each(function () {
          var menuSize = parseInt($(this).data("size"));
          if (menuSize > 15) {
            $(this).addClass("text-smallest");
          } else if (menuSize > 10) {
            $(this).addClass("text-smaller");
          } else if (menuSize > 5) {
            $(this).addClass("text-small");
          }
        });

        // end -- */

        if ($("#site-header").hasClass("header-scroll")) {
          if ($("body").hasClass("template-index")) {
            $("body").addClass("index-margin-fix");
          }

          window.lst = $(window).scrollTop();

          $(".site-nav.style--classic .submenu").css(
            "top",
            $(".site-header").outerHeight()
          );

          $(window).on(
            "scroll.sticky-header",
            function () {
              if (!window.blockStickyHeader) {
                var st = $(window).scrollTop();

                if (st < 0 || Math.abs(lst - st) <= 5) return;

                if (st == 0) {
                  this.$siteHeader.removeClass("animate");
                  this.$siteHeader.removeClass("fix");
                  this.$siteHeader.removeClass("ready");
                } else if (st <= lst && !this.$siteHeader.hasClass("fix")) {
                  this.$siteHeader.addClass("fix");
                  setTimeout(
                    function () {
                      this.$siteHeader.addClass("ready");
                    }.bind(this),
                    5
                  );
                  setTimeout(
                    function () {
                      this.$siteHeader.addClass("animate");
                    }.bind(this),
                    25
                  );
                } else if (st > lst && this.$siteHeader.hasClass("animate")) {
                  this.$siteHeader.removeClass("animate");
                  setTimeout(
                    function () {
                      this.$siteHeader.removeClass("fix");
                      this.$siteHeader.removeClass("ready");
                    }.bind(this),
                    105
                  );
                }

                window.lst = st;
              }
            }.bind(this)
          );
        }

      },

      unmount: function () {
        $("#site-menu-handle").off(".cuberNav");
        $("#site-cart-handle a").off(".cuberNav");
        $("#site-filter-handle").off(".cuberNav");
        $("#site-search-handle a").off(".cuberNav");
        $("#site-search-handle").off(".cuberNav");
        $('a[href="#search"]').off(".cuberNav");
        $(".site-close-handle, #site-overlay").off(".cuberNav");
        $(".site-nav.style--classic .has-submenu").off(".cuberNav");
        $(".site-nav.style--sidebar .has-submenu:not(.collections-menu)").children("a").off(".cuberNav");
        $(".site-nav.style--sidebar .has-babymenu:not(.collections-menu)").children("a").off(".cuberNav");
        $(".style--classic .has-babymenu").off(".cuberNav");

        $("#site-search-handle").removeClass("hover-in hover-out");
        $(".site-nav .has-submenu, .site-nav .has-babymenu").removeClass("active");
        $(".submenu, .babymenu").stop(true, true).hide().attr("aria-expanded", "false");
        $("body").removeClass("opened-submenu opened-submenu-flag desktop--add-some-padding");
        $(".site-overlay").removeClass("active");

        this.$siteNav.removeClass("active");
        this.$siteOverlay.removeClass("active");

        $(".fixing-scroll-now .site-box-background").removeClass(
          "sidebar-move"
        );
        $("body").removeClass("sidebar-move");

        $(window).off("scroll.sticky-header");
      },
    },

    // COLLECTION

    Collection: {
      $collectionGrid: null,
      $collectionNext: null,
      $collectionNextLink: null,

      mount: function () {
        if ($(".box__paginate").length > 0) {
          this.$collectionGrid = $("#section-collection");
          this.$collectionNext = $(".box__paginate");
          this.$collectionNextLink = $(".box__paginate a");

          this.$collectionNextLink.append(
            '<div class="preloader"><span>.</span><span>.</span><span>.</span></div>'
          );

          this.$collectionNextLink
          .off("click.cuberCollectionNext")
          .on(
            "click.cuberCollectionNext",
            function (e) {
              this.$collectionNextLink.addClass("loading");
              var nextPageURL = this.$collectionNextLink.attr("href");

              $.ajax({
                url: nextPageURL,
              }).done(
                function (data) {
                  this.$collectionNextLink.removeClass("loading");
                  this.$collectionNext.before(
                    $(data).find(".site-box.box__collection")
                  );

                  var i = 0;
                  this.$collectionGrid
                    .find(".box__collection:not(.active)")
                    .each(function () {
                      setTimeout(
                        function () {
                          $(this).addClass("active");
                        }.bind(this),
                        100 * i++
                      );
                    });

                  if ($(data).find(".site-box.box__paginate").length > 0) {
                    this.$collectionNextLink.attr(
                      "href",
                      $(data).find(".site-box.box__paginate a").attr("href")
                    );
                  } else {
                    this.$collectionNext.remove();
                  }
                }.bind(this)
              );

              e.preventDefault();
            }.bind(this)
          );
        }

        $(window)
          .on(
            "resize.collection-grid",
            window.debounce(
              function () {
                this._resizeCollection();
              }.bind(this),
              300
            )
          )
          .trigger("resize.collection-grid");
        this._resizeCollection();
        setTimeout(
          function () {
            this._resizeCollection();
          }.bind(this),
          1001
        );

        // empty grid fix

        var collectionSize = parseInt($(".box__heading").data("size"));

        if (collectionSize > 0 && collectionSize < 4) {
          for (var i = 0; i < 4 - collectionSize; i++) {
            $("#section-collection").append(
              '<div class="site-box box--small box--typo-small lap--hide box--no-padding box__collection active" />'
            );
          }
        }
      },

      _resizeCollection: function () {
        if (
          $("#fix-me-header").css("display") == "block" &&
          $("#fix-me-collection").css("display") == "block"
        ) {
          var wh = $(window).height();
          var h = wh - $(".site-header").outerHeight();

          if (h > 720) {
            $(".mount-products .site-box.box__collection_image").attr(
              "style",
              "height:" + h + "px !important; min-height: 0 !important;"
            );
          } else {
            h = 720;

            if (
              $(".mount-products .site-box.box__collection_image").length > 0
            ) {
              $(".mount-products .site-box.box__heading").attr(
                "style",
                "height:" +
                  (wh - $(".site-header").outerHeight()) +
                  "px !important; min-height: 0 !important;"
              );
              $(".mount-products .site-box.box__collection_image").attr(
                "style",
                "height:" +
                  (wh - $(".site-header").outerHeight()) +
                  "px !important; min-height: 0 !important;"
              );
            }
          }
        } else {
          $(
            ".mount-products .site-box.box__collection, .mount-products .site-box.box__heading"
          ).attr("style", "");
        }
      },

      unmount: function () {
        $(window).off("resize.collection-grid");
        if (this.$collectionNextLink) {
          this.$collectionNextLink.off(".cuberCollectionNext");
        }
        $(".box__paginate .preloader").remove();
      },
    },

    // PRODUCT

    Product: {
      $productGallery: null,
      $productGalleryItem: null,
      $productGalleryIndex: null,

      $productCarousel: null,
      $productCarouselImgs: null,
      productFlkty: null,

      $productStuff: null,
      productStuffMove: false,

      mount: function ($product, origin = false) {
        var productIsDisabled = false;
        if (
          $product.find(".product--section").data("hide-variants") &&
          $product.find(".product--section").data("product-available")
        ) {
          const productWrapper = $product.find('.product--section')
          const productId = productWrapper.data('id')
          
          if ($product.find(`#ProductJson-${productId}`).length > 0) {
            this._advancedOptionsSelector(
              $product, 
              JSON.parse($product.find(`#ProductJson-${productId}`).text())
            );
          }
        } else if (
          $product.find(".product--section").data("hide-variants") &&
          !$product.find(".product--section").data("product-available")
        ) {
          productIsDisabled = true;
        }

        // Product gallery

        var _this = {};
        $product.data("po", _this);

        _this.$productGallery = $product.find(".box__product-gallery");
        _this.$productGalleryItem = $product.find(
          ".box__product-gallery .gallery-item"
        );

        _this.$productGallery.append(
          '<div class="gallery-index out-with-you"><span class="current">' +
            (window.CuberProductImageIndex != undefined
              ? window.CuberProductImageIndex + 1
              : 1) +
            '</span> / <span class="total">' +
            _this.$productGalleryItem.length +
            "</span></div>"
        );
        _this.$productGalleryIndex = _this.$productGallery.find(
          ".gallery-index .current"
        );

        // Product zoom

        if ($("#product-zoom-in").length > 0) {
          $("body").append(
            '<div id="product-zoomed-image"><img /><div id="product-zoom-out" class="product-zoom expand"><span class="zoom-out">' +
              $.themeAssets.iconZoom +
              "</span></div></div>"
          );

          $("#product-zoom-in")
          .off("click.cuberProductZoom")
          .on(
            "click.cuberProductZoom",
            function (e) {
              // animation out

              $("#section-product")
                .find(".site-box.box__product-content")
                .addClass("animate");
              setTimeout(function () {
                $("#section-product")
                  .find(".site-box.box__product-content")
                  .addClass("expand");
                $("body").addClass("kill-overflow");
              }, 10);

              $("#section-product")
                .find(".site-box.box__product-gallery")
                .stop()
                .animate({ opacity: 0 }, 200);
              $(
                "#shopify-section-header, #shopify-section-footer, .site-sharing"
              )
                .stop()
                .animate({ opacity: 0 }, 200);

              // object

              var $image = $("#product-zoomed-image img");
              $image.attr(
                "src",
                $(".gallery-item")
                  .eq(parseInt(_this.$productGalleryIndex.html()) - 1)
                  .data("master")
              );

              setTimeout(
                function () {
                  if ($image[0].naturalWidth > 0) {
                    this._productZoomMount($image);
                  } else {
                    $image.on(
                      "load",
                      function () {
                        this._productZoomMount($image);
                      }.bind(this)
                    );
                  }
                }.bind(this),
                200
              );
            }.bind(this)
          );

          $("#product-zoom-out")
          .off("click.cuberProductZoom")
          .on(
            "click.cuberProductZoom",
            function (e) {
              setTimeout(function () {
                // animation out

                $("#section-product")
                  .find(".site-box.box__product-content")
                  .removeClass("expand");
                $("body").removeClass("kill-overflow");
                setTimeout(function () {
                  $("#section-product")
                    .find(".site-box.box__product-content")
                    .removeClass("animate");
                }, 400);

                $("#section-product")
                  .find(".site-box.box__product-gallery")
                  .stop()
                  .animate({ opacity: 1 }, 200);
                $(
                  "#shopify-section-header, #shopify-section-footer, .site-sharing"
                )
                  .stop()
                  .animate({ opacity: 1 }, 200);
              }, 150);

              // object

              this._productZoomUnmount();
            }.bind(this)
          );
        }

        // Add to cart (& ajax)
        
        if (!$product.find(".product--section").hasClass("onboarding-true")) {
          this.initProductForm($product, productIsDisabled);
        }

        if ($product.find(".qty-button").length > 0) {
          var $productQty = $product.find(".quantity-selector");

          if (
            parseInt($productQty.val()) - 1 <
            parseInt($productQty.attr("min"))
          ) {
            $product.find(".qty-minus").addClass("disabled");
          }
          if (
            parseInt($productQty.val()) + 1 >
            parseInt($productQty.attr("max"))
          ) {
            $product.find(".qty-plus").addClass("disabled");
          }

          $product.find(".qty-minus")
          .off('click.cuberProductQty')
          .on(
            "click.cuberProductQty",
            function ($productQty, $productQtyPlus, e) {
              if (!$(e.target).hasClass("disabled")) {
                var currentQty = parseInt($productQty.val());
                if (currentQty - 1 >= parseInt($productQty.attr("min"))) {
                  $productQty.val(currentQty - 1);
                  $productQtyPlus.removeClass("disabled");
                }
                if (currentQty - 1 <= parseInt($productQty.attr("min"))) {
                  $(e.target).addClass("disabled");
                }
              }
              e.preventDefault();
            }.bind(this, $productQty, $product.find(".qty-plus"))
          );

          $product.find(".qty-plus")
          .off("click.cuberProductQty")
          .on(
            "click.cuberProductQty",
            function ($productQty, $productQtyMinus, e) {
              if (!$(e.target).hasClass("disabled")) {
                var currentQty = parseInt($productQty.val());
                if (currentQty + 1 <= parseInt($productQty.attr("max"))) {
                  $productQty.val(currentQty + 1);
                  $productQtyMinus.removeClass("disabled");
                }
                if (currentQty + 1 >= parseInt($productQty.attr("max"))) {
                  $(e.target).addClass("disabled");
                }
              }
              e.preventDefault();
            }.bind(this, $productQty, $product.find(".qty-minus"))
          );
        }

        if (
          $product.find(".product--add-to-cart-form").length > 0 &&
          $product.find(".product--add-to-cart-form").data("type") ==
            "overlay" &&
          !$("html").hasClass("ie9")
        ) {
          var $form = $product.find(".product--add-to-cart-form form");

          if ($form.attr("action").indexOf(".js") < 0) {
            $form.attr("action", $form.attr("action") + ".js");
          }

          $form
          .off("submit.cuberProductOverlay")
          .on("submit.cuberProductOverlay", function (e) {
            e.preventDefault();
          });
        }
      },

      resizeGallery: function (gallery) {
        if ( $(window).width() < 769 ) {
          gallery.$productCarousel.parent().css({ height: 'auto!important', minHeight: 0, top: 'auto' })
        } else {
          const helloBar = document.querySelector(".helloBar--is-sticky");
          const headerEl = document.querySelector(".mainHeader__wrapper");
          let headerHeight = parseInt(headerEl.offsetHeight);
          if (helloBar) {
            headerHeight += parseInt(helloBar.offsetHeight);
          }
          const galleryHeight = $(window).height() - headerHeight + 'px'
          gallery.$productCarousel.parent().css({ height: galleryHeight, minHeight: galleryHeight, top: headerHeight + 'px' })
        }
      },

      _productZoomMount: function ($image) {
        $("#product-zoomed-image").css("display", "block");
        $image.css({ left: 0, top: 0 });

        $(window)
          .off("mousemove.product-zoom")
          .on("mousemove.product-zoom", function (e) {
            e.preventDefault();
            window.clientX = e.clientX;
            window.clientY = e.clientY;
            var x =
              (e.clientX * ($(window).width() - $image.width())) /
            $(window).width();
          var y =
            (e.clientY * ($(window).height() - $image.height())) /
            $(window).height();

          $image.css({ left: x, top: y });
        });

        if ($image[0].naturalWidth <= $image[0].naturalHeight) {
          $image.addClass("portrait");
        } else {
          $image.addClass("landscape");
        }
        $image.data("ratio", $image[0].naturalWidth / $image[0].naturalHeight);

        $(window)
          .off("resize.product-zoom")
          .on("resize.product-zoom", function () {
            var rf = $(window).width() > 768 ? 1 : 2;

            if ($image.hasClass("portrait")) {
              $image.css("width", $(window).width() * rf);
              $image.css(
                "height",
                ($(window).width() * rf) / $image.data("ratio")
              );
            } else {
              $image.css("height", $(window).height() * rf);
              $image.css(
                "width",
                $(window).height() * rf * $image.data("ratio")
              );

              if ($image.width() < $(window).width()) {
                $image.css("width", $(window).width() * rf);
                $image.css(
                  "height",
                  ($(window).width() * rf) / $image.data("ratio")
                );
              }
            }

            var x =
              (window.clientX * ($(window).width() - $image.width())) /
              $(window).width();
            var y =
              (window.clientY * ($(window).height() - $image.height())) /
              $(window).height();
          })
          .trigger("resize");

        $image.css("opacity", 1);
      },

      _productZoomUnmount: function () {
        $("#product-zoomed-image img").css("opacity", "0");

        setTimeout(function () {
          $(window).off("resize.product-zoom");
          $(window).off("mousemove.product-zoom");
          $("#product-zoomed-image img").attr("src", "");
          $("#product-zoomed-image").css("display", "none");
        }, 300);
      },

      _isValidVariantIdForUrl: function (variantId) {
        return variantId != null && variantId !== '' && String(variantId) !== 'undefined'
      },

      _shouldUpdateBrowserVariantUrl: function () {
        return !$('body').hasClass('template-collection') && !$('body').hasClass('template-index')
      },

      initProductForm: function ($product, pdisabled) {
        const productFormApi = this
        var firstVariantEver = true;
        
        const productWrapper = $product.find('.product--section')
        const productId = productWrapper.data('id')
        
        if ($product.find(`#ProductJson-${productId}`).length > 0) {
          
          const productJson = document.getElementById(`ProductJson-${productId}`).textContent.trim()
          var productSingleObject = JSON.parse(productJson),
            productVariants = productSingleObject.variants;
          
          $product.find("form select.product-variants")
          .off("change.cuberProductVariants")
          .on("change.cuberProductVariants",
            function (e) {
              this._initProductVariantChange(
                false,
                productSingleObject,
                $product
              );
            }.bind(this)
          );
          this._initProductVariantChange(true, productSingleObject, $product);

          if ($product.find('skio-plan-picker').length > 0) {
            const refreshSkioAtcPrice = function () {
              const skioPicker = $product.find('skio-plan-picker')[0];
              if (skioPicker && typeof skioPicker.updateExternalElements === 'function') {
                skioPicker.updateExternalElements();
              }
            };
            setTimeout(refreshSkioAtcPrice, 0);
            setTimeout(refreshSkioAtcPrice, 150);
            setTimeout(refreshSkioAtcPrice, 400);
          }
          
          if (
            $product
              .find(".product--add-to-cart-form")
              .hasClass("style--classic")
          ) {
            $product
              .find("select.product-variants:not(.styled)")
              .each(function () {
                $(this).addClass("styled");
              });

            $product.find(".product-variant").removeClass("hidden");

            if (pdisabled) {
              $product.find(".product-variant").css("display", "none");
            }
          } else {
            var i = 1;
            const hasSubs = $product.find(".cart-functions")
            .hasClass("has-sub")
            $product.find(".product-variant").each(function (j) {
              var color = window.returnColorVariant($(this).find("label").text())
                ? true
                : false,
              varDOM = `<ul class="color-${color}${ hasSubs ? ' has-subs' : '' }" data-option="option${(j + 1)}">`;

              $(this)
                .find(".product-variants option")
                .each(function () {
                  const variantColor = $(this).data('variant-color')
                  const variantAvailable = $(this).data('available')
                  const fullPrice = $(this).data('full-price')
                  const units = $(this).data('units')
                  const unitCost = $(this).data('unit-cost')
                  const compareAt = $(this).data('compare-at')
                  const variantPrice = $(this).data('price')
                  let variantId = $(this).data('variant-id')

                  if (!productFormApi._isValidVariantIdForUrl(variantId) && productSingleObject?.variants) {
                    const optionValue = $(this).val()
                    const matchedVariant = productSingleObject.variants.find(v =>
                      v.available && (v.options?.includes(optionValue) || v.title === optionValue)
                    )
                    if (matchedVariant) variantId = matchedVariant.id
                  }
                  
                  const formattedVal = $(this).val().split(" ").pop()
                  varDOM +=
                    `<li 
                      ${($(this).is(":selected") ? ` class="variant-selector active${variantAvailable ? '' : ' disabled' }"` : ` class="variant-selector${variantAvailable ? '' : ' disabled' }"`)}
                      tabindex="0" 
                      data-text="${$(this).val()}"
                      data-full-price="${fullPrice}"
                      data-unit-count="${units}"
                      data-unit-cost="${unitCost}"
                      data-compare-at="${compareAt}"
                      ${productFormApi._isValidVariantIdForUrl(variantId) ? `data-variant-id="${variantId}"` : ''}
                      data-price="${variantPrice}">
                      ${(variantColor && hasSubs) ? `<span class="variant-selector-color" style="background-color: ${variantColor}"></span>` : ''}
                      <span ${ color ? ` style="background-color: ${formattedVal}"` : ""}>
                        ${$(this).val()}
                      </span>`
                  varDOM += '</li>'
                });

              varDOM += "</ul>";
              $(this).find("select").hide();
              $(this).append(varDOM);
              
              $(this).removeClass("hidden");
              const productForm = $product.find('form')
              
              let selectedVariantTitle = ''
              $(this)
                .find("ul li")
                .off("click.cuberProductVariants keyup.cuberProductVariants")
                .on("click.cuberProductVariants", e => {
                  const $select = $(this).parent().parent().find('[name="id"]');
                  const $variantSelect = $(this).parent().parent().find('select');
                  const variantInput = productForm.find('[name="id"]').get(0);
                  const $selected = $(e.currentTarget)
                  $('.variant-selector').removeClass('active')
                  $(e.currentTarget).addClass('active')
                  const selectedText = $selected.data('text')
                  const selectedVariantId = $selected.data('variant-id')
                  $variantSelect.val(selectedText).change()
                  $select.find('option').each( (i, option) => {
                    if ( $(option).val().toString() === selectedVariantId.toString() ) {
                      selectedVariantTitle = $(option).data('title')
                      $select.val($(option).val()).change();
                      // $select.val($(option).val()).trigger("change")
                    }
                  })
                  
                  variantInput.dispatchEvent( new Event("change", { bubbles: true, detail: { variantId: selectedVariantId } }) );
                  
                  if (
                    productFormApi._isValidVariantIdForUrl(selectedVariantId) &&
                    productFormApi._shouldUpdateBrowserVariantUrl()
                  ) {
                    const url = new URL(window.location.href);
                    url.searchParams.set('variant', selectedVariantId);
                    history.replaceState({}, '', url.toString());
                  }
              });

              $(this)
                .find("ul li")
                .on("keyup.cuberProductVariants", function (e) {
                  if (e.keyCode == 13) {
                    $(this)
                      .parent()
                      .parent()
                      .find("select")
                      .val($(this).data('text'))
                      .change();
                  }
                });
            });

            if (pdisabled) {
              $product.find(".product-variant").find("li").addClass("disabled");
            }
          }

          if (
            productSingleObject.variants.length == 1 &&
            productSingleObject.variants[0].title.indexOf("Default") >= 0
          ) {
            $product.find(".product-variant").hide();
          }

          if (!window.__CUBER_DEBUG__.skioBound) {
            window.__CUBER_DEBUG__.skioBound = true;
            document.addEventListener('skio::select-selling-plan-group', function (e) {
              // e.detail.variant, e.detail.group, e.detail.key, e.detail.sellingPlan
              const productId = e.detail.product.id
              const selectedVariantId = e.detail.variant?.id
              const $form = $(`#product_form_${productId}`).length
                ? $(`#product_form_${productId}`)
                : $(`form[action*="/cart/add"][data-productid="${productId}"]`);
              const $productSelect = $form.find('#productSelect');
              if ($productSelect.length && selectedVariantId !== undefined) {
                $productSelect
                  .val(selectedVariantId)
                  .trigger("change");
                const selectEl = $productSelect[0];
                if (selectEl) {
                  selectEl.dispatchEvent(new Event("change"));
                }
              }

              if (window.atcs?.length && selectedVariantId !== undefined) {
                window.atcs.forEach(function (atc) {
                  const atcProductId = atc.$el?.closest('form')?.getAttribute('data-productid') || atc.$el?.dataset?.productId;
                  if (!productId || String(atcProductId) === String(productId)) {
                    atc.setVariantId(selectedVariantId);
                    if (e.detail.variant?.title && atc.setVariantTitle) {
                      atc.setVariantTitle(e.detail.variant.title);
                    }
                  }
                });
              }

              if (
                productFormApi._isValidVariantIdForUrl(selectedVariantId) &&
                productFormApi._shouldUpdateBrowserVariantUrl()
              ) {
                const url = new URL(window.location.href);
                url.searchParams.set('variant', selectedVariantId);
                if (e.detail.sellingPlan?.id) {
                  url.searchParams.set('selling_plan', e.detail.sellingPlan.id);
                } else {
                  url.searchParams.delete('selling_plan');
                }
                history.replaceState({}, '', url.toString());
              }
            });
          }
        }
      },

      _getProductVariant: function ($product) {
        /* ----
					Get current variant
					---- */

        var optionArray = [];

        $product.find("form select.product-variants").each(function () {
          optionArray.push($(this).find(":selected").val());
        });

        return optionArray;
      },

      _initProductVariantChange: function (
        firstTime,
        productSingleObject,
        $product
      ) {
        var variant = null,
          options = this._getProductVariant($product);
        productSingleObject.variants.forEach(function (el) {
          var variantOptions = el.options || [];
          if (
            variantOptions.length === options.length &&
            variantOptions.every(function (opt, index) {
              return opt === options[index];
            })
          ) {
            variant = el;
          }
        });

        this._productSelectCallback(variant, $product, productSingleObject);
        this._productSelectCallback(
          variant,
          $(".add-to-cart-bar"),
          productSingleObject
        );
        
        if (
          !firstTime &&
          $product.find("#productSelect option").length > 1 &&
          !$("body").hasClass("template-index") && !$('body').hasClass('template-collection')
        ) {
          this._updateProductVariantState(variant);
        }
        if ( $product.find("#productSelect option").length > 1 ) {
          const selectedOption = $product.find('#productSelect option:selected')
          if ( selectedOption ) {
            if ( selectedOption.data('price') ) {
              $addToCartText = $product.find(".add-to-cart-text")
              $addToCartText.text(`Add to cart | ${selectedOption.data('price')}`)
            }
          }
        }
      },

      _updateProductVariantState: function (variant) {
        if (!('replaceState' in history) || !variant) return;
        if (!this._shouldUpdateBrowserVariantUrl()) return;
        if (!this._isValidVariantIdForUrl(variant.id)) return;

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({ path: url.toString() }, '', url.toString());

        // Keep your side effects
        // window.atc?.setVariantId?.(variant.id);
        // window.atc?.setVariantTitle?.(variant.title);
      },

      _productSelectCallback: function (
        variant,
        $product,
        productSingleObject
      ) {
        var _po = $product.data("po");
        var $addToCart = $product.find(".product--add-to-cart-form"),
          $addToCartButton = $addToCart.find('button[type="submit"]'),
          $productPrice = $product.find(".product-price"),
          $compareAtPrice = $product.find("#comparePrice"),
          $quantityElements = $product.find(
            ".quantity-selector, label + .js-qty"
          ),
          $quantityElementsHolder = $product.find(".quantity-selector-holder"),
          $addToCartText = $product.find(".add-to-cart-text"),
          $productGallery = $product.find(".box__product-gallery");
      
        const $addToCartPrices = $('.add-btn-price')
        const $comparePrices = $('.add-btn-compare-at-price')
        
        if (variant) {
          // Set cart value id
          $product
            .find("#productSelect")
            .find('option[value="' + variant.id + '"]')
            .prop("selected", true);

          // Swipe to variant slide

          if (variant.featured_image != null) {
            var variantImg = $productGallery.find(
              '.gallery-item[data-variant-img="' +
                variant.featured_image.id +
                '"]'
            );

            if (
              $productGallery.hasClass("scroll") &&
              variantImg.length > 0 &&
              $(window).width() > 1024
            ) {
              if ($(window).scrollTop() > 0) {
                $("html, body")
                  .stop()
                  .animate(
                    { scrollTop: $productGallery.offset().top },
                    150,
                    function () {
                      $(window).off("scroll.to-junk");
                    }
                  );
              }

              variantImg.prependTo(
                $product.find(".box__product-gallery .site-box-content")
              );
            } else if (_po != undefined && variantImg.length > 0) {
              var productGalleryEle = $('.box__product-gallery._slider .site-box-content.slider-for');
              if (productGalleryEle) {
                productGalleryEle.slick('slickGoTo', variantImg.data("index"));
              }
              if (
                _po.productFlkty != undefined &&
                variantImg.data("index") != _po.productFlkty.selectedElement
              ) {
                _po.productFlkty.select(variantImg.data("index"));
              } else {
                window.CuberProductImageIndex = variantImg.data("index");
              }
            }
          }

          // Disable other variants

          if ($addToCart.hasClass("style--minimal")) {
            $product.find(".product-variant ul").each(function () {
              var option = variant[$(this).data("option")];
              $(this)
                .find("li")
                .each(function () {
                  $(this).removeClass("active");
                  if (option == $(this).data("text")) {
                    $(this).addClass("active");
                  }
                });
            });
          }

          // Edit cart buttons based on stock

          var $variantQuantity = $product.find(".variant-quantity");
          $variantQuantity.text("");

          var DOMVariant = $product
            .find("#productSelect")
            .find('option[value="' + variant.id + '"]');
          if (DOMVariant.attr("data-quantity") == "0") {
            if (DOMVariant.attr("data-inventory") == "continue") {
              $variantQuantity.html(window.product_words_preorder);
            } else if (DOMVariant.attr("data-inventory") == "deny") {
              $variantQuantity.html(window.product_words_no_products);
            }
          } else if (DOMVariant.attr("data-quantity") == "1") {
            $variantQuantity.html(window.product_words_one_product);
          } else if (parseInt(DOMVariant.attr("data-quantity")) < 5) {
            $variantQuantity.html(
              window.product_words_few_products.replace(
                "{{ count }}",
                DOMVariant.attr("data-quantity")
              )
            );
          } else if (!variant.available) {
            $variantQuantity.html(window.product_words_no_products);
          }

          if (variant.available) {
            $quantityElements.prop("max", 999);
            $addToCartButton.removeClass("disabled").prop("disabled", false);
            if ( !$addToCartButton.data('no-change-text') ) {
              $addToCartText.text(
                $("body").hasClass("template-product-pre-order")
                  ? $addToCartText.data("text")
                  : window.product_words_add_to_cart_button
              );
            }
            $quantityElements.show();
            if ($quantityElementsHolder != null) {
              $quantityElementsHolder.show();
            }
          } else {
            $addToCartButton.addClass("disabled").prop("disabled", true);
            $addToCartText.text(window.product_words_sold_out_variant);
            $quantityElements.hide();
            if ($quantityElementsHolder != null) {
              $quantityElementsHolder.hide();
            }
          }

          // Update price

          if ( !variant.selling_plan_allocations.length ) {
            let isAvailable = variant.available
            if ( variant.available ) {
              $('#addToCartCustom, .sidecart-atc-btn').removeAttr('disabled').css('pointer-events', 'auto');
              $('.add-to-cart-text').text('Add to Cart')
            } else {
              $('#addToCartCustom, .sidecart-atc-btn').attr('disabled', true).css('pointer-events', 'none');
              $('.add-to-cart-text').text('Sold Out')
            }
            
            if ( !variant.compare_at_price ) {
              $('.add-btn-compare-at-price', $product).each(function(index, $compareAtLabel){
                $($compareAtLabel).hide()
                $($compareAtLabel).val('')
              })
            } else {
              $('.add-btn-compare-at-price', $product).each(function(index, $compareAtLabel){
                $($compareAtLabel).show()
                $($compareAtLabel).html(theme.Currency.formatMoney(variant.compare_at_price, window.shop_money_format))
              })
            }
            $('.add-btn-price', $product).each(function(index, $atcLabel) {
              $($atcLabel).text(theme.Currency.formatMoney(variant.price, window.shop_money_format))
            })
          }
          
          if ( !variant.selling_plan_allocations?.length ) {
            $productPrice.html(
              theme.Currency.formatMoney(variant.price, window.shop_money_format)
            );
            if ( variant.compare_at_price > variant.price ) {
              $compareAtPrice.html(
                variant.compare_at_price ? theme.Currency.formatMoney(variant.compare_at_price, window.shop_money_format) : ''
              );
            }
          }
          
          const hasSkioPlanPicker =
            $product.find('skio-plan-picker').length > 0 ||
            $product.find('.cart-functions').hasClass('has-sub');

          if ( !hasSkioPlanPicker && $('.selling-plan-dropdown').length === 0 ) {
            let variantPrice = variant.price
            let variantCompareAt = variant.compare_at_price
            if ( variant.compare_at_price && variant.compare_at_price > variant.price ) {
              $comparePrices.each( (index, $priceDiv) => {
                $($priceDiv).html(
                  theme.Currency.formatMoney(variantCompareAt, window.shop_money_format)
                );
              })
            } else {
              $comparePrices.each( (index, $priceDiv) => {
                $($priceDiv).html('');
              })
            }
            $addToCartPrices.each( (index, $priceDiv) => {
              $($priceDiv).html(
                theme.Currency.formatMoney(variantPrice, window.shop_money_format)
              );
            })
          }
          
          $productPrice.attr("data-price", variant.price / 100);
          $compareAtPrice.attr("data-price", variant.compare_at_price / 100);

          // Update sku

          if ($product.find(".variant-sku").length > 0) {
            if (variant) {
              $product.find(".variant-sku").text(variant.sku);
            } else {
              $product.find(".variant-sku").empty();
            }
          }
        } else {
          // Disable variant completely
          $addToCartButton.addClass("disabled").prop("disabled", true);
          $addToCartText.text(window.product_words_unavailable_variant);
          $quantityElements.hide();
          if ($quantityElementsHolder != null) {
            $quantityElementsHolder.hide();
          }
        }

        if ($product.find(".qty-button").length > 0) {
          var $productQty = $product.find(".quantity-selector");
          $product.find(".qty-minus").removeClass("disabled");
          $product.find(".qty-plus").removeClass("disabled");

          if (
            parseInt($productQty.val()) - 1 <
            parseInt($productQty.attr("min"))
          ) {
            $product.find(".qty-minus").addClass("disabled");
          }
          if (
            parseInt($productQty.val()) + 1 >
            parseInt($productQty.attr("max"))
          ) {
            $product.find(".qty-plus").addClass("disabled");
          }
        }
        if ( $product.find('.gwButton').length > 0 ) {
          $('.gwButton').show()
        }
      },

      _advancedOptionsSelector: function ($product, productJson) {
        var om = {};
        $product.data("om", om);
        var forceMutation = false;
        var $addToCartForm = $product.find(".product--add-to-cart-form");
        // if (window.MutationObserver && $addToCartForm.length) {
        //   if (
        //     typeof observer === "object" &&
        //     typeof observer.disconnect === "function"
        //   ) {
        //     observer.disconnect();
        //   }
        //   var config = { childList: true, subtree: true };
        //   var observer = new MutationObserver(function () {
        //     Shopify.linkOptionSelectors(productJson, $product);
        //     observer.disconnect();
        //   });
        //   if (forceMutation) {
        //     Shopify.linkOptionSelectors(productJson, $product);
        //   }
        //   observer.observe($addToCartForm[0], config);
        // }
      },

      unmount: function ($product) {
        window.__CUBER_DEBUG__.inc('Product.unmount', {
          id: $product && $product.attr ? $product.attr('id') : undefined,
          classes: $product && $product.attr ? $product.attr('class') : undefined,
        });

        var po = $product && $product.data ? $product.data("po") : null;

        $(window).off("scroll.product-gallery");
        $(window).off("resize.position-product-zoom");
        $(window).off("resize.product-zoom");
        $(window).off("mousemove.product-zoom");

        if ($product && $product.length) {
          $product.find(".qty-minus").off(".cuberProductQty");
          $product.find(".qty-plus").off(".cuberProductQty");
          $product.find("form select.product-variants").off(".cuberProductVariants");
          $product.find(".product--add-to-cart-form form").off(".cuberProductOverlay");
          $product.find(".variant-selector").off(".cuberProductVariants");
          $product.find(".gallery-index").remove();
        }

        if (po && po.$productCarousel && typeof po.$productCarousel.off === "function") {
          po.$productCarousel.off("scroll.flickity");
          po.$productCarousel.off("select.flickity");
        }

        if (po && po.productFlkty && typeof po.productFlkty.destroy === "function") {
          po.productFlkty.destroy();
        }

        $("#product-zoom-in").off(".cuberProductZoom");
        $("#product-zoom-out").off(".cuberProductZoom");

        if (!$(".mount-product").length) {
          $("#product-zoomed-image").remove();
        }

        if ($product && $product.length) {
          $product.removeData("po");
          $product.find(".lazyload").off("lazyloaded");
          $product.find("#productSelect").off();
          $product.find(".product-variant ul li").off(".cuberProductVariants");
          $product.find(".product-variants:not(.styled)").removeClass("styled");
          $product.find(".product-variant").removeClass("hidden");
          $product.removeData("om");
        }
        $("#product-zoomed-image img").css({ opacity: "", width: "", height: "", left: "", top: "" }).removeClass("portrait landscape");
      },
    },

    Main: {
      $searchForm: null,
      $searchResults: null,
      $searchPreloader: null,
      $searchPagination: null,

      $body: null,
      $siteHeader: null,
      $siteFooter: null,

      $siteBoxes: null,

      _mountScrollMovers: function (props) {
        var $parent = props["parent"],
          parentOutOfFocus = false;

        setTimeout(function () {
          props["items"].removeClass("out-with-you");
        }, 1000);
        props["items"].addClass("animate-owy");

        $(window).off("scroll.scroll-movers")
        .on(
          "scroll.scroll-movers",
          function () {
           if ( $parent ) {
             if (
                !parentOutOfFocus && $parent.offset() && 
                $(window).scrollTop() + $(window).height() >
                  $parent.offset().top + $parent.height()
              ) {
                // after element
                props["items"].addClass("out-with-you");
                parentOutOfFocus = true;
              } else if (
                parentOutOfFocus && $parent.offset() && 
                $(window).scrollTop() + $(window).height() <=
                  $parent.offset().top + $parent.height()
              ) {
                // within element
                parentOutOfFocus = false;
                props["items"].removeClass("out-with-you");
              }
           }
          }.bind(this)
        );
      },

      _mobileSharingInit: function () {
        $(".touchevents .site-sharing .icon")
        .off("touchstart.cuberSharing")
        .on("touchstart.cuberSharing", function (e) {
          e.preventDefault();
          var $parent = $(this).parent();

          if ($parent.hasClass("hover")) {
            $parent.removeClass("hover");
          } else {
            $parent.addClass("hover");
          }
        });

        $(".touchevents .site-sharing a")
        .off("touchstart.cuberSharing")
        .on("touchstart.cuberSharing", function (e) {
          $(this).parent().removeClass("hover");
        });
      },

      _resizeEverything: function () {
        this.$body.css("paddingTop", this.$siteHeader.outerHeight(true));

        if (this.$body.hasClass("template-index")) {
          if ($("#fix-me-header").css("display") == "block") {
            $(".index-section:first-child .fix-me-with-margin").css(
              "marginTop",
              -this.$siteHeader.outerHeight()
            );
            $(".index-section:first-child .fix-me-with-height").css(
              "height",
              $(window).height() - this.$siteHeader.outerHeight()
            );
          } 
        } else {
          if ($("#fix-me-header").css("display") == "block") {
            $(".fix-me-with-margin").each(
              function (key, elm) {
                if ($(elm).outerHeight() < $(window).height()) {
                  $(elm).css("marginTop", -this.$siteHeader.outerHeight());
                } else {
                  $(elm).css("marginTop", "0");
                }
              }.bind(this)
            );

            $(".fix-me-with-height-hard").css({
              height: $(window).height() - this.$siteHeader.outerHeight(),
              "min-height": $(window).height() - this.$siteHeader.outerHeight(),
            });
            $(".fix-me-with-height").css({
              "min-height": $(window).height() - this.$siteHeader.outerHeight(),
            });
          } else {
            $(".fix-me-with-margin").css("marginTop", "0");
            $(".fix-me-with-height, .fix-me-with-height-hard").attr(
              "style",
              ""
            );
          }
        }

        if ($(".mount-product").length > 0) {
          $(".mount-product").each(
            function (key, elm) {
              if (window.CuberFixGalleryItem) {
                $(elm)
                  .find(".gallery-item")
                  .css(
                    "height",
                    ($(window).height() - this.$siteHeader.outerHeight()) * 0.8
                  );
              }

              $(elm).find(".product--section").removeClass("sticky-because");
              if (
                $(elm).find(".site-box.box__product-gallery").css("content") !=
                  '"fix-me-also"' &&
                $(elm).find(".site-box.box__product-gallery").height() <
                  $(elm).find(".site-box.box__product-content").height()
              ) {
                $(elm).find(".product--section").addClass("sticky-because");
              }
            }.bind(this)
          );

        }

        $(".site-header.desktop-view--classic .submenu").css(
          "top",
          $(".site-header").outerHeight()
        );

        if ($("#site-menu-handle").css("opacity") == "1") {
          $(".site-nav.style--sidebar a, #site-menu-handle").attr(
            "tabIndex",
            0
          );
        } else {
          $(".site-nav.style--sidebar a, #site-menu-handle").attr(
            "tabIndex",
            -1
          );
        }
      },

      _animateEverything: function (firstAnimation) {
        var i = 0;

        this.$siteBoxes.each(function () {
          var vp = 0;

          if (
            !$(this).hasClass("active") &&
            $(window).scrollTop() + $(window).height() >
              $(this).offset().top + vp
          ) {
            i++;

            setTimeout(
              function () {
                $(this).addClass("active");
              }.bind(this),
              100 * i
            );
          }
        });

        if (
          !this.$siteFooter.hasClass("active") &&
          $(window).scrollTop() + $(window).height() >
            this.$siteFooter.offset().top + 150
        ) {
          this.$siteFooter.addClass("active");
          this.$siteFooter.find(".site-box").addClass("active");
        }
      },

      _mountCustomFooter: function ($footer) {
        var txtColor = $footer.data("color_txt"),
          bgColor = $footer.data("color_bg"),
          blockId = "#" + $footer.attr("id");

        var style =
          '<style type="text/css">' +
          blockId +
          " .site-box-background.with-image:after { background-color: " +
          bgColor +
          "; } " +
          blockId +
          " .site-box-content { color: " +
          txtColor +
          "; } " +
          blockId +
          " .site-box-content .title:after { background: " +
          txtColor +
          "; } " +
          blockId +
          " .site-box-content .button { background: " +
          txtColor +
          " !important; color: " +
          window.colorLightness(txtColor) +
          " !important; } " +
          blockId +
          " .site-box-content .button svg * { fill: " +
          window.colorLightness(txtColor) +
          " !important; }</style>";

        $footer.append(style);
      },

      mount: function () {
        // Required before animation mount
        window.__CUBER_DEBUG__.inc('Main.mount');
        $(".rte").fitVids();

        // if ($(".mount-gallery").length > 0) {
        //   this._mountCustomGalleries();
        // }

        if ($(".box__collection-footer").length > 0) {
          $(".box__collection-footer").each(
            function (key, elm) {
              this._mountCustomFooter($(elm));
            }.bind(this)
          );
        }

        // ..continue

        this.$siteBoxes = $(".site-box:not(.footer-box)");
        this.$siteFooter = $(".site-footer");

        if (!$("body").hasClass("ie9")) {
          this._animateEverything(true);
          $(window).off("scroll.fade-animation").on(
            "scroll.fade-animation",
            function (e) {
              this._animateEverything(false);
            }.bind(this)
          );
        }

        if (window.show_preloader == "true") {
          $(".lazyload").each(function () {
            if (
              $(this).parent().hasClass("site-box-background") ||
              $(this).parent().hasClass("box--product-image")
            ) {
              $(this).parent().addClass("show-lazy-preloader");
              $(this).off("lazyloaded").on("lazyloaded", function () {
                $(this).parent().removeClass("show-lazy-preloader");
              });
            }
          });
        }

        $("html.no-touchevents a[href]:not([target='_blank'])").each(function () {
          window.animateSiteOff($(this));
        });

        //

        this.$body = $("body");
        this.$siteHeader = $("#site-header");

        $(window).off("resize.cuberMain").on("resize.cuberMain", 
          window.debounce(
            function () {
              this._resizeEverything();
            }.bind(this),
            300
          )
        );
        this._resizeEverything();

        setTimeout(
          function () {
            this._resizeEverything();
          }.bind(this),
          1000
        );

        if (
          $(".logo-img").length > 0 &&
          !$(".logo-img img")[0].naturalWidth > 0
        ) {
          $(".logo-img img").off("load").on("load", function () {
            window.CUBER.Main._resizeEverything();
          });
        }

        this.$searchForm = $(".search-bar:not(.no-ajax)");
        this.$searchResults = $("#search-results");
        this.$searchPreloader = $("#site-search .preloader");

        this.$searchForm.find('input[type="search"]')
        .off("keyup.cuberSearch")
        .on("keyup.cuberSearch",
          window.debounce(
            function () {
              this._ajaxSearchForm();
            }.bind(this),
            300
          )
        );

        this.$searchForm
        .off("submit.cuberSearch")
        .on("submit.cuberSearch", function (e) {
            e.preventDefault();
            this._ajaxSearchForm();
          }.bind(this)
        );

        // tabs & toggles

        if ($(".krown-tabs").data("design") == "toggles") {
          $(".krown-tabs").each(function () {
            var $titles = $(this).children(".titles").children("h5"),
              $contents = $(this).find(".contents").children("div"),
              i = 0;

            $titles.each(function () {
              $contents.eq(i++).insertAfter($(this));

              $(this).off("click.cuberTabs").on("click.cuberTabs", function () {
                var $toggle = $(this).next(".tab");

                if (!$(this).hasClass("opened")) {
                  $(this).addClass("opened");
                  $toggle.stop().slideDown(200);
                } else {
                  $(this).removeClass("opened");
                  $toggle.stop().slideUp(200);
                }
              });
            });

            $(this).find(".contents").remove();
          });
        } else {
          $(".krown-tabs").each(function () {
            var $titles = $(this).children(".titles").children("h5"),
              $contents = $(this).children(".contents").children("div"),
              $openedT = $titles.eq(0),
              $openedC = $contents.eq(0);

            $openedT.addClass("opened");
            $openedC.stop().slideDown(0);

            $titles.find("a").prop("href", "#")
            .off("click.cuberTabs")
            .on("click.cuberTabs", function (e) {
              $openedT.removeClass("opened");
              $openedT = $(this);
              $openedT.addClass("opened");

              $openedC.stop().slideUp(200);
              $openedC = $contents.eq($(this).index());
              $openedC.stop().delay(200).slideDown(200);

              e.preventDefault();
            });
          });
        }

        if ($(".site-footer .info").length > 0) {
          if ($(".site-footer .info").html().split("").length > 18) {
            $(".site-footer .info").addClass("smaller");
          }
        }

        if (document.location.href.indexOf("customer_posted=true") > 0) {
          setTimeout(function () {
            $("html, body").animate(
              { scrollTop: $("#contact_form").offset().top },
              1
            );
          }, 2000);
        }
      },

      _mountCustomGalleries: function () {
        if (
          $("#product-gallery-split").length > 0 ||
          $("#collection-gallery-split").length > 0
        ) {
          window.imagesLoadedLIGHT($(".rte.extract-images"), function () {
            var gallery = [];

            $(".rte.extract-images img").each(function () {
              gallery.push({
                src: $(this).attr("src"),
                alt: $(this).attr("alt"),
                style:
                  $(this)[0].naturalWidth > $(this)[0].naturalHeight
                    ? "landscape"
                    : "portrait",
                sized: false,
              });
              $(this).remove();
            });
            $(".rte.extract-images p:empty").remove();

            var galleryDOM = "";

            gallery.forEach(function (item, key) {
              var size = "box--bigger";

              if (item["style"] == "landscape") {
                size = "box--bigger lap--box--landscape";
              } else if (item["style"] == "portrait") {
                if (item["sized"]) {
                  size = "box--big lap--box--portrait-small";
                } else {
                  if (key + 1 < gallery.length) {
                    if (gallery[key + 1]["style"] == "portrait") {
                      size = "box--big lap--box--portrait-small";
                      gallery[key + 1]["sized"] = true;
                    } else {
                      size = "box--bigger lap--box--portrait-large";
                    }
                  } else {
                    size = "box--bigger lap--box--portrait-large";
                  }
                }
              }

              var placeholder = item["src"].replace("10x", "placeholder");
              if (placeholder.indexOf("placeholder") < 0) {
                placeholder = placeholder.replace(
                  /(.jpg|.jpeg|.gif|.png)/i,
                  "_placeholder$1"
                );
              }

              var set = [
                placeholder.replace("_placeholder", "_600x"),
                placeholder.replace("_placeholder", "_860x"),
                placeholder.replace("_placeholder", "_1100x"),
                placeholder.replace("_placeholder", "_1600x"),
                placeholder.replace("_placeholder", "_2100x"),
              ];

              galleryDOM +=
                '<div class="site-box ' +
                size +
                '"><span class="site-box-background with-image" aria-hidden="true"><img class="lazyload" alt="' +
                item["alt"] +
                '" src="' +
                set[0] +
                '" data-srcset="' +
                set[0] +
                " 480w, " +
                set[1] +
                " 720w, " +
                set[2] +
                " 960w, " +
                set[3] +
                " 1440w, " +
                set[4] +
                ' 1920w" srcset="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" data-sizes="auto" /></span></div>';
            });

            if (galleryDOM != "") {
              if ($("body").hasClass("template-collection")) {
                $("#collection-gallery-split").html(galleryDOM);
              } else if ($("body").hasClass("template-product")) {
                $("#product-gallery-split").html(galleryDOM);
              }

              $("#shopify-section-product")
                .parent()
                .addClass("lift-related-up");
              $(
                "#collection-gallery-split .site-box, #product-gallery-split .site-box"
              ).each(function () {
                window.CUBER.Main.$siteBoxes.push($(this));
              });
              window.CUBER.Main._animateEverything(false);

              if (window.show_preloader == "true") {
                $(
                  "#collection-gallery-split .lazyload, #product-gallery-split .lazyload"
                ).each(function () {
                  if (
                    $(this).parent().hasClass("site-box-background") ||
                    $(this).parent().hasClass("box--product-image")
                  ) {
                    $(this).parent().addClass("show-lazy-preloader");
                    $(this).on("lazyloaded", function () {
                      $(this).parent().removeClass("show-lazy-preloader");
                    });
                  }
                });
              }
            } else {
              $("#collection-gallery-split, #product-gallery-split").remove();
            }

            $(window).trigger("scroll.fade-animation");
          });
        }
      },

      _ajaxSearchForm: function () {
        this.$searchPreloader.css("opacity", 1);

        $.ajax({
          type: this.$searchForm.prop("method"),
          url: this.$searchForm.prop("action"),
          data: this.$searchForm.serialize(),
          success: function (data) {
            this.$searchResults.html(
              $(data).find(".search-results.with-results")
            );
            this.$searchPreloader.css("opacity", 0);

            $("#site-search").off("scroll.search-pagination");

            if ($(".search-results").find(".next-page").length > 0) {
              this.$searchPagination = $(".search-results").find(".next-page");
              $("#site-search").off("scroll.search-pagination").on(
                "scroll.search-pagination",
                this._ajaxSearchPagination.bind(this)
              );
            }
          }.bind(this),
        });
      },

      _ajaxSearchPagination: function () {
        if (
          $("#site-search").scrollTop() + $(window).height() >=
          this.$searchPagination.offset().top - 250
        ) {
          this.$searchPreloader.css({
            opacity: 1,
            top: "auto",
            bottom: "-60px",
          });
          $("#site-search").off("scroll.search-pagination");

          $.ajax({
            url: this.$searchPagination.attr("href"),
            success: function (data) {
              this.$searchResults.find(".next-page").remove();
              this.$searchResults.append($(data).find(".search-item"));

              if ($(data).find(".search-results .next-page").length > 0) {
                this.$searchResults.append(
                  $(data).find(".search-results .next-page")
                );
                this.$searchPagination =
                  $(".search-results").find(".next-page");
                $("#site-search").off("scroll.search-pagination").on(
                  "scroll.search-pagination",
                  this._ajaxSearchPagination.bind(this)
                );
              }

              this.$searchPreloader.css({
                opacity: 0,
                top: "20px",
                bottom: "auto",
              });
            }.bind(this),
          });
        }
      },

      _countdownBannerInterval: null,

      _countdownBannerInit: function () {
        if (this._countdownBannerInterval) {
          clearInterval(this._countdownBannerInterval);
        }

        $(window)
        .off("beforeunload.cuberCountdown")
        .on("beforeunload.cuberCountdown", () => clearInterval(this._countdownBannerInterval));

        if ($(".mount-landing-banner").find(".countdown").length > 0) {
          var $countdown = $(".mount-landing-banner").find(".countdown");

          var $days = $countdown.find(".days"),
            $hours = $countdown.find(".hours"),
            $minutes = $countdown.find(".minutes"),
            $seconds = $countdown.find(".seconds");

          var date = $countdown.data("date").split(","),
            gmt = parseInt($countdown.data("timezone")),
            count = new Date(date[0], date[1] - 1, date[2], date[3]),
            timezone = count.getTimezoneOffset() / -60;

          if (timezone != gmt) {
            count.setHours(parseInt(date[3]) + timezone - gmt);
          }

          this._countdownBannerInterval = setInterval(
            function () {
              if ($countdown.hasClass("hide")) {
                $countdown.removeClass("hide");
              }

              var now = new Date().getTime();
              distance = count - now;

              var days = Math.floor(distance / (1000 * 60 * 60 * 24)),
                hours = Math.floor(
                  (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
                ),
                minutes = Math.floor(
                  (distance % (1000 * 60 * 60)) / (1000 * 60)
                ),
                seconds = Math.floor((distance % (1000 * 60)) / 1000);

              $days.html(days < 10 ? "0" + days : days);
              $hours.html(hours < 10 ? "0" + hours : hours);
              $minutes.html(minutes < 10 ? "0" + minutes : minutes);
              $seconds.html(seconds < 10 ? "0" + seconds : seconds);

              if (distance < 0) {
                clearInterval(this._countdownBannerInterval);
                $days.html("00");
                $hours.html("00");
                $minutes.html("00");
                $seconds.html("00");
              }
            }.bind(this),
            1000
          );
        }
      },

      unmount: function () {
        $(window).off("scroll.scroll-movers");
        $(window).off("resize.cuberMain");
        $(window).off("scroll.fade-animation");
        $(window).off("beforeunload.cuberCountdown");
        $("#site-search").off("scroll.search-pagination");

        if (this.$searchForm) {
          this.$searchForm.find('input[type="search"]').off(".cuberSearch");
          this.$searchForm.off(".cuberSearch");
        }

        $(".touchevents .site-sharing .icon").off(".cuberSharing");
        $(".touchevents .site-sharing a").off(".cuberSharing");

        if (this._countdownBannerInterval) {
          clearInterval(this._countdownBannerInterval);
          this._countdownBannerInterval = null;
        }
      },
    },

    Contact: {
      mount: function ($elm) {
        if ($elm.find(".contact-map-holder").length > 0) {
          if ($elm.find(".contact-map-object").data("address") != "") {
            if (typeof google !== "undefined") {
              this._createMap(
                $elm.attr("id"),
                $elm.find(".contact-map-object"),
                $elm.find(".contact-map-address-holder")
              );
            } else {
              if (window.loadingGoogleMapsScript) {
                $elm.ti = setInterval(
                  function ($elm) {
                    if (typeof google !== "undefined") {
                      clearInterval($elm.ti);
                      this._createMap(
                        $elm.attr("id"),
                        $elm.find(".contact-map-object"),
                        $elm.find(".contact-map-address-holder")
                      );
                    }
                  }.bind(this, $elm),
                  100
                );
              } else {
                window.loadingGoogleMapsScript = true;
                $.getScript(
                  "https://maps.googleapis.com/maps/api/js?v=3&key=" +
                    $elm.find(".contact-map-holder").data("key")
                ).done(
                  function () {
                    this._createMap(
                      $elm.attr("id"),
                      $elm.find(".contact-map-object"),
                      $elm.find(".contact-map-address-holder")
                    );
                  }.bind(this)
                );
              }
            }
          }
        }
      },

      _createMap: function (id, $mapInsert, $mapAddress) {
        $mapInsert.attr("id", "contact-map-" + id);

        var coordsKey = "map-coords-" + $mapInsert.attr("id"),
          coordsStorage =
            localStorage.getItem(coordsKey) != null
              ? JSON.parse(localStorage.getItem(coordsKey))
              : null,
          mapLat = 0,
          mapLong = 0;

        if (
          coordsStorage != null &&
          coordsStorage["address"] == $mapInsert.data("address")
        ) {
          mapLat = coordsStorage["lat"];
          mapLong = coordsStorage["long"];
        }

        var geocoder, map, address;

        geocoder = new google.maps.Geocoder();
        address = $mapInsert.data("address");

        var mapOptions = {
          zoom: $mapInsert.data("zoom"),
          center: new google.maps.LatLng(mapLat, mapLong),
          streetViewControl: false,
          scrollwheel: true,
          panControl: false,
          mapTypeControl: false,
          overviewMapControl: false,
          zoomControl: false,
          draggable: true,
          styles:
            $mapInsert.data("style") == "light"
              ? window.lightMapStyle
              : window.darkMapStyle,
        };

        map = new google.maps.Map(
          document.getElementById($mapInsert.attr("id")),
          mapOptions
        );

        if (mapLat != 0 || mapLong != 0) {
          var markerOptions = {
            position: new google.maps.LatLng(mapLat, mapLong),
            map: map,
            title: address,
          };

          if ($mapInsert.data("marker") != "none") {
            markerOptions["icon"] = {
              url: $mapInsert.data("marker"),
              scaledSize: new google.maps.Size(60, 60),
            };
          }

          $mapAddress
            .find("a")
            .attr(
              "href",
              "http://www.google.com/maps/place/" + mapLat + "," + mapLong
            );
          var contentString = $mapAddress.html();
          var infowindow = new google.maps.InfoWindow({
            content: contentString,
          });

          var marker = new google.maps.Marker(markerOptions);
          marker.addListener("click", function () {
            infowindow.open(map, marker);
            if ($(window).width() < 480) {
              $(".template-page-contact .box__heading .title").css(
                "marginTop",
                50
              );
            } else if ($(window).width() < 768) {
              $(".template-page-contact .box__heading .title").css(
                "marginTop",
                100
              );
            }
          });

          if ($(window).width() > 768) {
            map.panBy(-150, 150);
          } else {
            map.panBy(-75, 75);
          }
        } else {
          if (geocoder) {
            geocoder.geocode({ address: address }, function (results, status) {
              if (status == google.maps.GeocoderStatus.OK) {
                if (status != google.maps.GeocoderStatus.ZERO_RESULTS) {
                  map.setCenter(results[0].geometry.location);

                  var markerOptions = {
                    position: results[0].geometry.location,
                    map: map,
                    title: address,
                  };

                  if ($mapInsert.data("marker") != "none") {
                    markerOptions["icon"] = {
                      url: $mapInsert.data("marker"),
                      scaledSize: new google.maps.Size(60, 60),
                    };
                  }

                  $mapAddress
                    .find("a")
                    .attr(
                      "href",
                      "http://www.google.com/maps/place/" +
                        results[0].geometry.location.lat() +
                        "," +
                        results[0].geometry.location.lng()
                    );
                  var contentString = $mapAddress.html();
                  var infowindow = new google.maps.InfoWindow({
                    content: contentString,
                  });

                  var marker = new google.maps.Marker(markerOptions);
                  marker.addListener("click", function () {
                    infowindow.open(map, marker);
                  });

                  if ($(window).width() > 768) {
                    map.panBy(-150, 150);
                  } else {
                    map.panBy(-75, 75);
                  }

                  localStorage.setItem(
                    coordsKey,
                    JSON.stringify({
                      address: $mapInsert.data("address"),
                      lat: results[0].geometry.location.lat(),
                      long: results[0].geometry.location.lng(),
                    })
                  );
                } else {
                  alert("No results found for the given address");
                }
              } else {
                console.debug(
                  "Geocode was not successful for the following reason: " +
                    status
                );
              }
            });
          }
        }
      },

      unmount: function () {},
    },

    // SCROLL

    Scroll: {
      $body: null,
      $footer: null,

      mount: function () {
        window.__CUBER_DEBUG__.inc('Scroll.mount');
        if (!$("html").hasClass("csspositionsticky")) {
          this.$body = $("body");
          this.$footer = $("#shopify-section-footer");

          // grid

          var scrollFixArray = [];

          if ($(window).width() > 768) {
            $(".site-box-container.container--fullscreen.box--can-stick").each(
              function () {

                var $boxChildren = $(this).children(".site-box");

                if ($boxChildren.length == 2) {
                  if (
                    $(this)
                      .children('.site-box[data-order="0"]')
                      .outerHeight(true) !=
                    $(this)
                      .children('.site-box[data-order="1"]')
                      .outerHeight(true)
                  ) {
                    var $bigChild = null,
                      $smallChild = null;

                    if (
                      $(this)
                        .children('.site-box[data-order="0"]')
                        .outerHeight(true) >
                      $(this)
                        .children('.site-box[data-order="1"]')
                        .outerHeight(true)
                    ) {
                      $bigChild = $(this).children('.site-box[data-order="0"]');
                      $smallChild = $(this).children(
                        '.site-box[data-order="1"]'
                      );
                    } else if (
                      $(this)
                        .children('.site-box[data-order="1"]')
                        .outerHeight(true) >
                      $(this)
                        .children('.site-box[data-order="0"]')
                        .outerHeight(true)
                    ) {
                      $bigChild = $(this).children('.site-box[data-order="1"]');
                      $smallChild = $(this).children(
                        '.site-box[data-order="0"]'
                      );
                    }

                    scrollFixArray.push({
                      parent: $(this),
                      "big-child": $bigChild,
                      "small-child": $smallChild,
                    });
                  }
                } else if ($boxChildren.length == 1) {
                  if (
                    $(this)
                      .children('.site-box[data-order="0"]')
                      .outerHeight(true) > $(window).height()
                  ) {
                    scrollFixArray.push({
                      parent: $(this),
                      "big-child": $(this).children(
                        '.site-box[data-order="0"]'
                      ),
                      "small-child": null,
                    });
                  }
                }
              }
            );
          }

          scrollFixArray.forEach(function (obj) {
            obj["parent"].removeClass("fixing-scroll-now");
            const windowHeight = $(window).height()
            const boxHeight = $('.box--big.box__sticky').height()
            const scrollBox = $('.box--big.box__scroll')
            const scrollHeight = scrollBox ? $(scrollBox).height() : 0
            let headerBuffer = $('header').height()
            if ( $('.helloBar__container') ) {
              headerBuffer += $('helloBar__container').height()
            }

            $('.box--big.box__sticky').css({
              top: boxHeight > scrollHeight 
                ? (boxHeight * -1) + windowHeight + 'px'
                : headerBuffer + 'px',
              bottom: "auto",
              position: 'sticky',
              marginLeft: "0",
            });

            if ( $('.box--big.box__sticky').hasClass('box__full-height') ) {
              $('.box--big.box__sticky').css({ height: $(window).height() - headerBuffer + 'px' })
            }

          });

          $(window).off("scroll.scroll-fix");

          scrollFixArray.forEach(function (obj) {
            if (
              $(window).scrollTop() + $(window).height() >=
              obj["parent"].offset().top + obj["parent"].outerHeight()
            ) {
              if (!$('.template-product') && obj["small-child"] != null) {
                obj["small-child"].css({
                  position: "absolute",
                  bottom: 0,
                  top: "auto",
                });
                if (obj["small-child"].attr("data-order") == "1") {
                  obj["small-child"].css("marginLeft", "50%");
                }
              }

              if (!$('.template-product') && obj["big-child"].attr("data-order") == "1") {
                obj["big-child"].css("marginLeft", "50%");
              }
            }
          });

          $(window)
            .off("scroll.scroll-fix")
            .on(
              "scroll.scroll-fix",
              function () {
                if ($(window).scrollTop() >= 0) {
                  scrollFixArray.forEach(function (obj) {
                    if (
                      $(window).scrollTop() >= obj["parent"].offset().top &&
                      $(window).scrollTop() + $(window).height() <
                        obj["parent"].offset().top +
                          obj["parent"].outerHeight() &&
                      !obj["parent"].hasClass("fixing-scroll-now")
                    ) {
                      obj["parent"].addClass("fixing-scroll-now");

                      if (obj["small-child"] != null) {

                        if ( $(window).width() > 1024 ) {
                          const windowHeight = $(window).height()
                          const boxHeight = $('.box--big.box__sticky').height()
                          const scrollBox = $('.box--big.box__scroll')
                          const scrollHeight = scrollBox ? $(scrollBox).height() : 0
                          let headerBuffer = $('header').height()
                          if ( $('.helloBar__container') ) {
                            headerBuffer += $('helloBar__container').height()
                          }
                          $('.box--big.box__sticky').css({
                            top: boxHeight > scrollHeight 
                              ? (boxHeight * -1) + windowHeight + 'px'
                              : headerBuffer + 'px'
                          });

                          if ( $('.box--big.box__sticky').hasClass('box__full-height') ) {
                            let headerBuffer = $('header').height()
                            if ( $('.helloBar__container') ) {
                              headerBuffer += $('helloBar__container').height()
                            }
                            $('.box--big.box__sticky').css({ height: $(window).height() - headerBuffer + 'px' })
                          }
                          
                          if (!$('.template-product') && obj["small-child"].attr("data-order") == "1") {
                            obj["small-child"].css("marginLeft", "50%");
                          }
  
                          if (obj["small-child"].height() > $(window).height()) {
                            obj["small-child"].addClass("ok-scroll");
                          }
                        } else {
                          $('.box--big.box__sticky').css({ position: 'relative' })
                        }
                      }

                      if (!$('.template-product') && obj["big-child"].attr("data-order") == "1") {
                        obj["big-child"].css("marginLeft", "50%");
                      }
                    }

                    if (
                      $(window).scrollTop() + $(window).height() >=
                        obj["parent"].offset().top +
                          obj["parent"].outerHeight() &&
                      obj["parent"].hasClass("fixing-scroll-now")
                    ) {
                      obj["parent"].removeClass("fixing-scroll-now");

                      if (obj["small-child"] != null) {
                        obj["small-child"].removeClass("ok-scroll");
                        if ( !$('.template-product') ) {
                          obj["small-child"].css({
                            position: "absolute",
                            bottom: 0,
                            top: "auto",
                          });
                        }
                      }
                    }

                    if (
                      $(window).scrollTop() < obj["parent"].offset().top &&
                      obj["parent"].hasClass("fixing-scroll-now")
                    ) {
                      obj["parent"].removeClass("fixing-scroll-now");
                      obj["big-child"].css("marginLeft", "0");
                      if ( $(window).width() > 1024 ) {
                        $('.box--big.box__sticky').css({
                          position: 'sticky',
                          top: ($('.box--big.box__sticky').height() * -1) + $(window).height() + 'px',
                          bottom: "auto",
                          marginLeft: "0",
                        });
                      } else {
                        $('.box--big.box__sticky').css({ position: 'relative' })
                      }
                    }
                    if (
                      obj["small-child"] != null &&
                      obj["small-child"].height() > $(window).height() &&
                      obj["small-child"].hasClass("ok-scroll")
                    ) {
                      var x = obj["big-child"].height() - $(window).height(),
                        y = $(window).height() - obj["small-child"].height(),
                        z = $(window).scrollTop();
                    }
                  });
                }
              }.bind(this)
            )
            .trigger("scroll.scroll-fix");

          $(window).off("resize.scroll-fix");
          $(window).on(
            "resize.scroll-fix",
            window.debounce(
              function () {
                window.CUBER.Scroll.mount();
              }.bind(this),
              250
            )
          );
        }
      },

      unmount: function () {
        $(window).off("resize.scroll-fix");
        $(window).off("scroll.scroll-fix");
      },
    },

    // IMAGES

    Images: {
      boxImages: [],

      mount: function () {
        window.__CUBER_DEBUG__.inc('Images.mount');
        this.boxImages = [];

        if ($(".box--product-image").length > 0) {
          $(".box--product-image:not(.on)").each(
            function (key, elm) {
              $(elm).addClass("on");
              this.boxImages.push({
                $elm: $(elm),
                img: $(elm).children("img")[0],
                srcset: $(elm).children("img").data("srcset"),
              });
            }.bind(this)
          );
        }

        $(window)
          .off("resize.box-images")
          .on(
            "resize.box-images",
            function () {
              this.boxImages.forEach(function (entry) {
                var desiredDensity =
                    window.devicePixelRatio <= 2 ? window.devicePixelRatio : 2,
                  desiredSize = entry["$elm"].width() * desiredDensity;
                if (entry["img"].naturalWidth > 0) {
                  if (
                    entry["$elm"].width() / entry["$elm"].height() <
                    entry["img"].naturalWidth / entry["img"].naturalHeight
                  ) {
                    var desiredHeight = Math.ceil(
                      entry["$elm"].height() * desiredDensity
                    );
                    desiredSize =
                      (desiredHeight * entry["img"].naturalWidth) /
                      entry["img"].naturalHeight;
                  }
                }

                if (desiredSize <= 480) {
                  entry["$elm"].css(
                    "backgroundImage",
                    "url(" + entry["srcset"].small + ")"
                  );
                } else if (desiredSize <= 960) {
                  entry["$elm"].css(
                    "backgroundImage",
                    "url(" + entry["srcset"].medium + ")"
                  );
                } else if (desiredSize <= 1440) {
                  entry["$elm"].css(
                    "backgroundImage",
                    "url(" + entry["srcset"].large + ")"
                  );
                } else if (desiredSize > 1440) {
                  entry["$elm"].css(
                    "backgroundImage",
                    "url(" + entry["srcset"].huge + ")"
                  );
                }
              });
            }.bind(this)
          )
          .trigger("resize.box-images");
      },

      unmount: function () {
        $(window).off("resize.box-images");
      },
    },

    Video: {
      mount: function () {
        window.__CUBER_DEBUG__.inc('Video.mount');
        if ($(".video-lightbox").length > 0) {
          $(".video-lightbox").magnificPopup({
            type: "iframe",
            iframe: {
              patterns: {
                youtube: {
                  index: "youtube.com",
                  id: "v=",
                  src: "//www.youtube.com/embed/%id%?rel=0&autoplay=1",
                },
              },
            },
          });
        }
      },

      unmount: function () {},
    },

    VideoBackground: {
      backgroundPlayers: {},

      mount: function () {
        window.__CUBER_DEBUG__.inc('VideoBackground.mount');
        if (
          $(".mount-video-background .site-box-video-background .player")
            .length > 0 &&
          $("html").hasClass("no-touchevents")
        ) {
          if (typeof YT == "undefined") {
            var tag = document.createElement("script");
            tag.src = "https://www.youtube.com/iframe_api";
            var firstScriptTag = document.getElementsByTagName("script")[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
          }

          $(".mount-video-background").each(
            function (key, elm) {
              this.backgroundPlayers[
                $(elm).find(".site-box-video-background .player").attr("id")
              ] = {
                player: null,
                selector: $(elm)
                  .find(".site-box-video-background .player")
                  .attr("id"),
                video: $(elm)
                  .find(".site-box-video-background")
                  .attr("data-video"),
              };
            }.bind(this)
          );

          window.onYouTubeIframeAPIReady = function () {
            for (var key in this.backgroundPlayers) {
              if (this.backgroundPlayers.hasOwnProperty(key)) {
                var item = this.backgroundPlayers[key];
                item["player"] = new YT.Player(item["selector"], {
                  height: "1080",
                  width: "1920",
                  suggestedQuality: "highres",
                  videoId: item["video"],
                  playerVars: {
                    autoplay: 1,
                    controls: 0,
                    showinfo: 0,
                    rel: 0,
                    enablejsapi: 1,
                    wmode: "transparent",
                  },
                  events: {
                    onReady: CUBER.VideoBackground._pkOnPlayerReady.bind(this),
                    onStateChange:
                      CUBER.VideoBackground._pkOnPlayerStateChange.bind(this),
                  },
                });
              }
            }
          }.bind(this);

          setTimeout(function () {
            $(".site-box-video-background").fadeIn();
          }, 2000);
        }
      },

      unmount: function () {},

      _pkOnPlayerStateChange: function (e) {
        var frm = $(e.target.getIframe());
        if (e.data === YT.PlayerState.PLAYING) {
          this.backgroundPlayers[frm.attr("id")]["player"].setPlaybackQuality(
            "hd1080"
          );
        }
        if (e.data === YT.PlayerState.ENDED) {
          this.backgroundPlayers[frm.attr("id")]["player"].playVideo();
        }
      },

      _pkOnPlayerReady: function (e) {
        var frm = $(e.target.getIframe());
        this.backgroundPlayers[frm.attr("id")]["player"].mute();
        this.backgroundPlayers[frm.attr("id")]["player"].playVideo();
      },
    },

    Banner: {
      $banner: null,

      _bannerKey: null,
      _bannerStorage: null,
      _bannerText: "",

      mount: function () {
        window.__CUBER_DEBUG__.inc('Banner.mount');
        this.$banner = $(".shopify-section.mount-banner");

        this._bannerKey = this.$banner.attr("id");
        this._bannerStorage = !localStorage.getItem(this._bannerKey)
          ? "empty"
          : JSON.parse(localStorage.getItem(this._bannerKey));
        this._bannerText = this._extractText(
          this.$banner.find(".box__banner .content").html()
        );

        var show = this.$banner.find(".box__banner").data("show");

        // alternate for specific pages
        if (
          $("body").hasClass("template-collection") &&
          this.$banner.find(".box__banner").data("collection") != "" &&
          this.$banner.find(".box__banner").data("collection") !=
            $("body").attr("id")
        ) {
          show = false;
        } else if (
          $("body").hasClass("template-product") &&
          this.$banner.find(".box__banner").data("product") != "" &&
          this.$banner.find(".box__banner").data("product") !=
            $("body").attr("id")
        ) {
          show = false;
        }

        if (
          show &&
          (this._bannerStorage == "empty" ||
            this._bannerStorage["content"] != this._bannerText)
        ) {
          setTimeout(
            function () {
              this._show(this.$banner);
            }.bind(this),
            400
          );

          this.$banner.find(".close").off("click.cuberBanner").on(
            "click.cuberBanner",
            function () {
              this._hide(this.$banner, true);
            }.bind(this)
          );
        }
      },

      _show: function ($banner) {
        $banner.addClass("active");
      },

      _hide: function ($banner, remember) {
        $banner.removeClass("active");

        if (remember) {
          localStorage.setItem(
            this._bannerKey,
            JSON.stringify({
              shown: "yes",
              content: this._bannerText,
            })
          );
        }
      },

      _extractText: function (content) {
        var span = document.createElement("span");
        span.innerHTML = content;
        return [span.textContent || span.innerText]
          .toString()
          .replace(/ +/g, "");
      },
    },

    Popup: {
      $popup: null,

      mount: function () {
        window.__CUBER_DEBUG__.inc('Popup.mount');
        this.$popup = $("#shopify-section-popup");

        var show = this.$popup.find(".popup-content").data("show"),
          freq = this.$popup.find(".popup-content").data("freq"),
          enable = this.$popup.find(".popup-content").data("enable");

        if (show > 0 && enable) {
          setTimeout(
            function () {
              this._trigger(show, freq);
            }.bind(this),
            parseInt(show * 1000)
          );
        }

        this.$popup.find(".site-close-handle").off("click.cuberPopup").on(
          "click.cuberPopup",
          function (e) {
            this._hide();
          }.bind(this)
        );

        this.$popup.find(".popup-background").off("click.cuberPopup").on(
          "click.cuberPopup",
          function (e) {
            this._hide();
          }.bind(this)
        );
      },

      _show: function () {
        this.$popup.addClass("active");
      },

      _hide: function () {
        this.$popup.removeClass("active");
      },

      _trigger: function (show, freq) {
        var popupKey = "popup-" + document.location.hostname,
          popupStorage =
            localStorage.getItem(popupKey) != null
              ? JSON.parse(localStorage.getItem(popupKey))
              : null;

        if (popupStorage != null) {
          if (popupStorage["show"] != show || popupStorage["freq"] != freq) {
            this._refreshStorage(popupKey, show, freq);

            // user saw the ad but settings are different - show it!
            this._show();
          } else {
            // user saw the ad so we need to check if he should see it again

            if (freq == "every") {
              if (
                sessionStorage[popupKey] == null ||
                sessionStorage[popupKey] != "shown"
              ) {
                this._show();
                this._refreshStorage(popupKey, show, freq);
              }
            } else {
              var shownAt = popupStorage["shown"],
                nowAt = new Date().getTime(),
                inBetween = Math.round((nowAt - shownAt) / 1000);

              if (freq == "day" && inBetween > 129600) {
                this._show();
                this._refreshStorage(popupKey, show, freq);
              } else if (freq == "week" && inBetween > 907200) {
                this._show();
                this._refreshStorage(popupKey, show, freq);
              }
            }
          }
        } else {
          this._refreshStorage(popupKey, show, freq);

          // user never saw the ad - show it!

          this._show();
        }
      },

      _refreshStorage: function (popupKey, show, freq) {
        localStorage.setItem(
          popupKey,
          JSON.stringify({
            show: show,
            freq: freq,
            shown: new Date().getTime(),
          })
        );

        sessionStorage[popupKey] = "shown";
      },

      unmount: function () {},
    },

    // SOCIAL

    Social: {
      mount: function ($elm) {
        window.__CUBER_DEBUG__.inc('Social.mount', {
          id: $elm && $elm.attr ? $elm.attr('id') : undefined,
          classes: $elm && $elm.attr ? $elm.attr('class') : undefined,
        });
        var $container = $elm.children(".site-box-container");
        var nameTwitter = $container.data("twitter");
        var nameInstagram = $container.data("instagram");

        $container.data("checkTwitter", "false");
        $container.data("checkInstagram", "false");

        var no = $container.data("posts"),
          noT = 0,
          noI = 0,
          socialArr = [];

        if (nameTwitter != "" && nameInstagram != "") {
          noT = Math.ceil(no / 2);
          noI = Math.floor(no / 2);
        } else if (nameTwitter != "") {
          noT = no;
        } else if (nameInstagram != "") {
          noI = no;
        }

        if (noI > 0) {
          var feed = new Instafeed({
            get: "user",
            userId: nameInstagram.split(".")[0],
            accessToken: nameInstagram,
            limit: noI,
            resolution: "standard_resolution",
            mock: true,
            sortBy: "random",
            success: function (obj) {
              obj.data.forEach(function (entry) {
                socialArr.push({
                  type: "instagram",
                  thumb: entry.images.standard_resolution.url,
                  link: entry.link,
                  caption:
                    typeof entry.caption === "object" && entry.caption !== null
                      ? entry.caption.text
                      : "",
                  likes: entry.likes.count,
                  time: new Date(entry.created_time * 1000).toLocaleDateString(
                    "en-US"
                  ),
                  timestamp: parseInt(entry.created_time),
                });
              });

              this._pushFeed("instagram", socialArr, nameTwitter, $container);
            }.bind(this),
          });

          feed.run();
        } else {
          this._pushFeed("instagram", socialArr, nameTwitter, $container);
        }

        if (noT > 0) {
          twitterFetcher.fetch({
            profile: { screenName: nameTwitter },
            dataOnly: true,
            maxTweets: noT,
            dateFunction: function (date) {
              return parse(date);
            },
            customCallback: function (obj) {
              obj.forEach(function (entry) {
                socialArr.push({
                  type: "twitter",
                  text: entry.tweet,
                  timestamp: Date.parse(entry.timestamp) / 1000,
                });
              });

              this._pushFeed("twitter", socialArr, nameTwitter, $container);
            }.bind(this),
          });
        } else {
          this._pushFeed("twitter", socialArr, nameTwitter, $container);
        }
      },

      _pushFeed: function (type, feed, nameTwitter, $container) {
        if (type == "twitter") {
          $container.data("checkTwitter", "true");
        } else if (type == "instagram") {
          $container.data("checkInstagram", "true");
        }

        if (
          $container.data("checkTwitter") == "true" &&
          $container.data("checkInstagram") == "true"
        ) {
          feed
            .sort(function (a, b) {
              return a.timestamp - b.timestamp;
            })
            .reverse();

          feed.forEach(
            function (entry, key) {
              var feedContent = "";

              if (entry.type == "twitter") {
                feedContent += '<div class="site-box-content">';
                feedContent +=
                  '<span class="icon" aria-hidden="true">' +
                  $.themeAssets.iconTwitter +
                  "</span>";
                feedContent += "<p>" + entry.text + "</p>";
                feedContent +=
                  '<a href="https://twitter.com/' +
                  nameTwitter +
                  '" target="_blank">@' +
                  nameTwitter +
                  "</a>";
                feedContent += "</div>";
              } else if (entry.type == "instagram") {
                feedContent +=
                  '<div class="site-box-content" style="background-image:url(' +
                  entry.thumb +
                  ')">';
                feedContent += '<a href="' + entry.link + '" target="_blank">';
                feedContent +=
                  '<span class="icon child" aria-hidden="true">' +
                  $.themeAssets.iconInstagram +
                  "</span>";
                feedContent +=
                  '<p class="caption child">' + entry.caption + "</p>";
                feedContent += '<div class="meta child">';
                feedContent +=
                  '<span class="likes">' +
                  $.themeAssets.iconHeart +
                  entry.likes +
                  "</span>";
                feedContent += '<span class="time">' + entry.time + "</span>";
                feedContent += "</div>";
                feedContent += "</a>";
                feedContent += "</div>";
              }

              $container
                .find('.site-box[data-order="' + (key + 1) + '"]')
                .removeClass("box__twitter")
                .removeClass("box__instagram")
                .addClass("box__" + entry.type)
                .html(feedContent);
            }.bind(this)
          );
        }
      },

      unmount: function () {
        //
      },
    }
  };

  $(document).on("ready", function () {
    window.__CUBER_DEBUG__.inc('document.ready.handler');
    window.CUBER.Nav.mount();
    window.CUBER.Main.mount();
    window.CUBER.Scroll.mount();

    if ($(".mount-social").length > 0) {
      $(".mount-social").each(function () {
        window.CUBER.Social.mount($(this));
      });
    }

    if ($(".mount-product").length > 0) {
      $(".mount-product").each(function () {
        
        window.CUBER.Product.mount($(this));
      });
    }
    if ($("body").hasClass("template-collection")) {
      window.CUBER.Collection.mount();
    }

    if ($(".mount-video-background").length > 0) {
      window.CUBER.VideoBackground.mount();
    }

    if ($(".mount-landing-banner").length > 0) {
      window.CUBER.Main._countdownBannerInit();
    }

    window.CUBER.Video.mount();
    window.CUBER.Popup.mount();
    window.CUBER.Banner.mount();

    // Section events

    // select

    $(document).on("shopify:section:select", function (e) {
      var $section = $(e.target);

      if ($section.hasClass("mount-header")) {
        if (
          $section.find("#site-header").hasClass("style--sidebar") ||
          $section.find("#site-header").hasClass("style--fullscreen")
        ) {
          if (!$section.find("#site-nav").hasClass("active")) {
            $("#site-menu-handle a").trigger("click");
          }
        }
      }

      if (
        $("#site-header").hasClass("desktop-view--minimal") &&
        $("#fix-me-header").css("display") == "none"
      ) {
        setTimeout(function () {
          $("html, body")
            .stop()
            .animate({ scrollTop: $section.offset().top }, 0);
        }, 400);
      }

      if ($section.hasClass("mount-popup")) {
        window.CUBER.Popup._show();
      }
      if ($section.hasClass("mount-banner")) {
        window.CUBER.Banner._show($section);
      }
    });

    // deselect

    $(document).on("shopify:section:deselect", function (e) {
      var $section = $(e.target);

      if ($section.hasClass("mount-header")) {
        if (
          $section.find("#site-header").hasClass("style--sidebar") ||
          $section.find("#site-header").hasClass("style--fullscreen")
        ) {
          if ($section.find("#site-nav").hasClass("active")) {
            $("#site-menu-handle a").trigger("click");
          }
        }
      }

      if ($section.hasClass("mount-popup")) {
        window.CUBER.Popup._hide();
      }
      if ($section.hasClass("mount-banner")) {
        window.CUBER.Banner._hide($section, false);
      }
    });

    // load

    $(document).on("shopify:section:load", function (e) {
      var $section = $(e.target);
      window.__CUBER_DEBUG__.inc('shopify:section:load', {
        id: $section.attr('id'),
        classes: $section.attr('class'),
      });

      if ($section.hasClass("mount-header")) {
        window.CUBER.Nav.mount();
      }
      if ($section.hasClass("mount-video")) {
        window.CUBER.Video.mount();
      }
      if ($section.hasClass("mount-video-background")) {
        window.CUBER.VideoBackground.mount();
      }
      if ($section.hasClass("mount-social")) {
        window.CUBER.Social.mount($section);
      }
      if ($section.hasClass("mount-product")) {
        window.CUBER.Product.mount($section);
      }
      if ($section.hasClass("mount-popup")) {
        window.CUBER.Popup.mount();
      }
      if ($section.hasClass("mount-banner")) {
        window.CUBER.Banner.mount();
      }
      if ($section.hasClass("mount-gallery")) {
        // window.CUBER.Main._mountCustomGalleries();
      }

      if ($section.hasClass("mount-landing-banner")) {
        window.CUBER.Main._countdownBannerInit();
      }

      window.CUBER.Main.mount();
      window.CUBER.Scroll.mount();
    });

    // unload

    $(document).on("shopify:section:unload", function (e) {
      var $section = $(e.target);

      window.__CUBER_DEBUG__.inc('shopify:section:unload', {
        id: $section.attr('id'),
        classes: $section.attr('class'),
      });

      if ($section.hasClass("mount-header")) {
        window.CUBER.Nav.unmount();
      }
      if ($section.hasClass("mount-images")) {
        window.CUBER.Images.unmount();
      }
      if ($section.hasClass("mount-video")) {
        window.CUBER.Video.unmount();
      }
      if ($section.hasClass("mount-social")) {
        window.CUBER.Social.unmount();
      }
      if ($section.hasClass("mount-product")) {
        window.CUBER.Product.unmount($section);
      }
      if ($section.hasClass("mount-map")) {
        window.CUBER.Contact.unmount();
      }

      window.CUBER.Main.unmount();
      window.CUBER.Scroll.unmount();
    });

    // blocks

    $(document).on("shopify:block:select", function (e) {
      var $block = $(e.target);

      if ($block.hasClass("slideshow-item")) {
        if (
          $block.closest(".responsive-flickity").hasClass("flickity-enabled")
        ) {
          $block
            .closest(".responsive-flickity")
            .data("flickity")
            .select($block.index());
        } else {
          $(window).scrollTop($block.offset().top);
        }
        $block
          .find(".caption, .title, .subtitle")
          .css("transform", "translateY(0)");
      } else if ($block.hasClass("box__collection-footer")) {
        window.CUBER.Main._mountCustomFooter($block);
      }
    });

    // Various stuff that doesn't need remounting

    $(".simple-grid select:not(.styled)").each(function () {
      $(this)
        .styledSelect({
          coverClass: "regular-select-cover",
          innerClass: "regular-select-inner",
        })
        .addClass("styled");
      $(this).parent().append($.themeAssets.arrowDown);
    });

    if ($("body").hasClass("template-customers-login")) {
      if ($("#RecoverPassword").length > 0) {
        $("#RecoverPassword").on("click", function (e) {
          $("#CustomerLoginForm").hide();
          $("#RecoverPasswordForm").show();
          $("#LoginRecoverTitle").html(
            $("#LoginRecoverTitle").data("password_recovery")
          );
          e.preventDefault();
        });

        $("#HideRecoverPasswordLink").on("click", function (e) {
          $("#RecoverPasswordForm").hide();
          $("#CustomerLoginForm").show();
          $("#LoginRecoverTitle").html($("#LoginRecoverTitle").data("login"));
          e.preventDefault();
        });

        if (window.location.hash == "#recover") {
          $("#RecoverPassword").trigger("click");
        }
      }
    } else if ($("body").hasClass("template-customers-addresses")) {
      $("#section-addresses a").on("click", function () {
        window.CUBER.Scroll.mount();
      });
    }

    if (
      $("body").hasClass("template-blog") ||
      $("body").hasClass("template-article")
    ) {
      window.CUBER.Main._mountScrollMovers({
        parent: $(".scroll-movers-parent"),
        items: $(".site-sharing"),
      });

      window.CUBER.Main._mobileSharingInit();
    }
  });
})(jQuery);

function response(data) {}

window._getLuminance = function (hexy) {
  var rgb = this._toRgb(hexy);
  return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
};

window._toRgb = function (hexy) {
  var hex = hexy.replace("rgb(", "");
  hex = hex.replace(")", "");
  hex = hex.replace(" ", "");
  hex = hex.replace(" ", "");
  hex = hex.split(",");
  return { r: hex[0], g: hex[1], b: hex[2] };
};

$(window).on("load", function () {
  setTimeout(function () {
    if (
      $("body").attr("id") == "challenge" ||
      location.pathname == "/challenge"
    ) {
      document.location.hash = "challenge";
      $("html, body").scrollTop(0);
    }
  }, 150);
});
$(document).ready(function () {
  window.__CUBER_DEBUG__.inc('jquery.ready.bottom');
  // Animate scroll to reviews section
  $("a.reviews-link", "body").on("click", function (e) {
    e.preventDefault();
    $("body,html").animate(
      { scrollTop: $("#shopify-product-reviews").offset().top - 90 + "px" },
      300,
      "swing"
    );
  });
  $("a.subscribe-link", "body").on("click", function (e) {
    e.preventDefault();
    $("body,html").animate({ scrollTop: 0 }, 300, "swing");
  });

  if ($(".ro_widget").length > 0 && $(".ro_widget").children().length > 0) {
    $(".add-to-cart-bar").addClass("has-subscription");
  }

  // subscriptions: open "Learn more about subscriptions" in another window as BOLD doesn't allow target="_blank"
  $(".cart-functions").on(
    "click",
    ".ro_widget span.bold-ro__recurring-text div a",
    function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      window.open(
        "https://www.foriawellness.com/pages/subscribe-save",
        "_blank"
      );
    }
  );

  if (!window.location.href.toString().includes("subscribe")) {
    if (window.BOLD && window.BOLD.common && window.BOLD.common.eventEmitter) {
      BOLD.common.eventEmitter.on(
        "BOLD_RECURRING_ORDERS_widget_loaded",
        function (e) {
          $(".ro_widget span.bold-ro__recurring-text div a").on(
            "click",
            function (e) {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
              window.open(
                "https://www.foriawellness.com/pages/subscribe-save",
                "_blank"
              );
            }
          );
          let discountPrice = document.querySelector(
            "#discountScriptPrice"
          ).innerHTML;
          let El = document.querySelector(".bold-ro__one-time-price");
          if (discountPrice.trim() != El.innerHTML.split(".")[0].trim()) {
            let cloneEl = El.cloneNode(true);
            cloneEl.classList.remove("bold-ro__one-time-price");
            cloneEl.classList.add("bold-ro__one-time-price--crossed");
            El.parentElement.appendChild(cloneEl);
          }
          El.innerHTML = discountPrice;
        }
      );
    }

    // subscriptions: add product-price to subscription price to allow it to change
    $(
      ".bold-ro__one-time-price:not(.bold-ro__one-time-price--crossed)"
    ).addClass("product-price");
    $("select.product-variants").on("change", function () {
      let discountPrice = document.querySelector("#discountScriptPrice");
      if (discountPrice !== null) {
        discountPrice = discountPrice.innerHTML;
        $(
          ".bold-ro__one-time-price:not(.bold-ro__one-time-price--crossed)"
        ).html(discountPrice);
      }
    });
  }

  // Add To Cart Bar

  $("button[name=add]").click(function () {
    var inAddToCartBar = $(this).parents(".add-to-cart-bar").length > 0;
    var productFormId = $(this).parents("form").attr("id");

    var eventCategory = "AddToCart";
    var eventAction = inAddToCartBar
      ? "click - sticky bar"
      : "click - product form";
    var eventLabel = productFormId;
    ga("send", "event", eventCategory, eventAction, eventLabel);
    dataLayer.push({ event: "AddToCart" });
    
    if (typeof klaviyo !== "undefined" && typeof item != "undefined") {
      klaviyo.track('Added to Cart', item);
    }
  });

  $("#shopify-section-cart_alert .close").on("click", function () {
    $("#shopify-section-cart_alert").fadeOut(400, function () {
      $("#shopify-section-cart_alert").removeClass("active");
    });
  });

  var track_promos_enabled = false;
  var promotions = [];
  var $promos = $(".template-index div.track-promotions");
  if ($promos.length > 0) {
    var idx = 1;
    $promos.each(function () {
        var promo_location = "home_" + idx;
        var $curr_promo = $(this);
        var $promo_blocks = $("div[data-promo-id]", $curr_promo);
        $promo_blocks.each(function () {
            var $block = $(this);
            var block_idx = 1;
            var block_location = promo_location;
            if ($promo_blocks.length > 1) {
                block_location += "_" + block_idx;
            }
            var promo_id = $block.attr("data-promo-id");
            var promo_name = $block.attr("data-promo-name");
            var promo_creative = $block.attr("data-promo-creative");
            var promo_details = {
                id: promo_id,
                name: promo_name,
                creative: promo_creative,
                position: block_location,
            };
            promotions.push(promo_details);
            
            // Remove any existing event handler to avoid multiple triggers
            $(".button, button, .promo-track-button", $block).off("click.cuberPromo").on("click.cuberPromo", function () {
                if (track_promos_enabled) {
                    gtag("event", "select_content", {
                        event_label: promo_id,
                        promotions: [promo_details],
                    });
                }
            });
            
            block_idx++;
        });
        idx++;
    });
  }

  if (promotions.length > 0 && typeof gtag != "undefined") {
    $(window).on("load", function () {
      gtag("event", "view_promotion", { promotions: promotions });
      track_promos_enabled = true;
    });
  }

  var videoObs = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (
          entry.isIntersecting === true &&
          !entry.target.classList.contains("loaded")
        ) {
          entry.target.classList.add("loaded")

          entry.target.querySelectorAll("source").forEach((src) => {
            src.setAttribute("src", src.getAttribute("data-src"))
          })

          entry.target.load()
          entry.target.play()
        }
      })
    },
    { threshold: [0] }
  )

  document.querySelectorAll("video").forEach((video) => {
    video.style.display = "block"
    videoObs.observe(video)
  })
});